import { PriceUpdatedFilterEnum } from 'src/components/Filters/StackedFilter/PriceUpdatedDateStackedFilter';
import { SaleDateFilterEnum } from 'src/components/Filters/StackedFilter/SaleDateStackedFilter';
import { DayOfWeek } from 'src/components/Selectors/DayOfWeekSelector/DayOfWeek.types';
import { TicketStatus } from 'src/components/Selectors/TicketStatusSelector/TicketStatus.types';
import { SiteThemeOption } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import {
  AggregateFunction,
  MathOperator,
  WindowFunction,
} from 'src/modals/ColumnSettings/TableCustomColumnModal/TableCustomColumnModal.types';
import { RestrictSelectionType } from 'src/modals/ListingDetails/components/PricingSection/AutoPricingSection.types';
import { OnSaleEventTableColumnId } from 'src/navigations/Routes/OnSaleDiscovery/OnSaleDiscoveryView.types';
import { SettingTab } from 'src/navigations/Routes/Settings/constants';
import { PurchaseFormulaFields } from 'src/tables/PurchaseTable/PurchaseTable.types';
import { RetailTableColumnId } from 'src/tables/RetailTable/RetailTable.types';
import { SaleFormulaFields } from 'src/tables/SalesTable/SalesTable.type';
import { EventsTableColumnId } from 'src/utils/columns/events/eventsColumnUtils.types';
import { MarketplacePaymentsTableColumnId } from 'src/utils/columns/marketplacePayments/marketplacePaymentsColumnsUtils.types';
import {
  PurchasesTableColumnId,
  PurchaseTableColumnGroupId,
} from 'src/utils/columns/purchases/purchasesColumnUtils.types';
import {
  RecentSalesTableColumnId,
  SalesReportTableColumnId,
  SalesReportTableGroupingColumnId,
  SalesReportTableValueColumnId,
  SalesTableColumnId,
  SalesTableFlattenedColumnId,
} from 'src/utils/columns/sales/salesColumnUtils.types';
import {
  ActionOutboxEntityType,
  AdCampaignState,
  ApiEventStatus,
  AutoPoInboundEmailClassificationType,
  AutoPricingCompFailureActionType,
  AutoPricingCompListingMode,
  AutoPricingOutlierMode,
  AutoPricingPauseType,
  AutoPricingResultType,
  AutoPricingUndercutMode,
  BroadcastErrorCode,
  BucketType,
  CommandOptionType,
  CompRowOffsetMode,
  ConfirmationDialogType,
  DealSplitType,
  DealThresholdSplitDirection,
  DeliveryType,
  EventDemandFactorType,
  EventGroupingType,
  EventNotificationStatus,
  EventNotificationType,
  EventTimeFrameFilter,
  EventUnpricedStatus,
  FilterOperationType,
  FlightDuration,
  GroupingType,
  InventoryViewMode,
  ListingNoteType,
  ListingPriceAdjustmentType,
  ListingStatus,
  Marketplace,
  MarketplaceOperationResultState,
  MarketplacePaymentLineType,
  MarketplacePaymentState,
  MarketplacePaymentTerm,
  NotificationType,
  OnSaleEventViewMode,
  PaymentMethodNameKnownRegex,
  PendingProofState,
  Permission,
  PermissionAccessArea,
  PointOfSaleFulfillmentState,
  PointOfSalePaymentState,
  PointOfSaleSaleStatus,
  PreDeliveryState,
  PricingFloorCeilingAdjustmentType,
  PurchaseOrderCostType,
  PurchaseOrderState,
  PurchasePaymentMethodType,
  PurchaseViewMode,
  QualityControlState,
  ReportGroupBy,
  ReportWidgetTypesInventory,
  Role,
  RowGroupSetting,
  SaleCancellationReason,
  SaleCostType,
  SaleLineItemChargeReason,
  SaleLineItemCreditReason,
  SalesViewMode,
  SectionGroupAreaType,
  SplitType,
  TagsValueType,
  TagValueInheritMode,
  TicketGroupEditReason,
  TicketType,
  TimePeriodType,
  TopLevelCategory,
  VenueZoneConfigType,
} from 'src/WebApiController';

import { FlightsTableColumnId } from '../../tables/SponsoredListings/CampaignFlightsTable/FlightsTableColumnConfig';
import { CampaignsTableColumnId } from '../../tables/SponsoredListings/CampaignsTableV2/CampaignsTableV2ColumnConfig';
import { SimplifiedUndercutMode } from '../autoPricingUtils';
import { AdCampaignsTableColumnId } from '../columns/adCampaigns/adCampaignsColumnUtils.types';
import { AdGroupsTableColumnId } from '../columns/adGroups/adGroupsColumnUtils.types';
import { CommissionReportTableValueColumnId } from '../columns/commission/commissionColumnUtils.types';
import { CommissionReportTableGroupingColumnId } from '../columns/commission/commissionColumnUtils.types';
import {
  CostOfGoodsSoldReportTableGroupingColumnId,
  CostOfGoodsSoldReportTableValueColumnId,
} from '../columns/costOfGoodsSold/costOfGoodsSoldColumnUtils.types';
import {
  ListingReportTableColumnId,
  ListingReportTableGroupingColumnId,
  ListingReportTableValueColumnId,
  ListingTableColumnId,
  ListingTableFlattenedColumnId,
} from '../columns/inventory/inventoryColumnUtils.types';
import { ListingFormulaFields } from '../columns/inventory/inventoryCustomColumnUtils';
import {
  PurchaseOrderLineItemReportTableGroupingColumnId,
  PurchaseOrderLineItemReportTableValueColumnId,
} from '../columns/purchaseOrderLineItem/purchaseOrderLineItemColumnUtils.types';
import {
  PurchaseReportTableGroupingColumnId,
  PurchaseReportTableValueColumnId,
} from '../columns/purchases/purchasesReportColumnUtils.types';
import {
  SaleCostAdjustmentsReportTableGroupingColumnId,
  SaleCostAdjustmentsReportTableValueColumnId,
} from '../columns/saleCostAdjustments/saleCostAdjustmentsColumnUtils.types';
import {
  SaleLineItemReportTableGroupingColumnId,
  SaleLineItemReportTableValueColumnId,
} from '../columns/saleLineItem/saleLineItemColumnUtils.types';
import {
  SoldTicketReportTableGroupingColumnId,
  SoldTicketReportTableValueColumnId,
} from '../columns/soldTicket/soldTicketColumnUtils.types';
import { TicketGroupReportTableGroupingColumnId } from '../columns/ticketGroup/ticketGroupColumnUtils.types';
import { TicketGroupReportTableValueColumnId } from '../columns/ticketGroup/ticketGroupColumnUtils.types';
import {
  EventMappingStateFilter,
  EventUiSort,
  LastReviewedSinceDate,
  TextFilterEnum,
  YesNoEnum,
} from '../eventQueryUtils';
import { ReportFilterEditability } from '../reportsFilterUtils';
import { ReportTypes } from '../reportsUtils';
import { PurchasePaymentStatus } from './../../WebApiController';
import { ContentId } from './contentId';
import { FormatContentId } from './formatContentId';

// NOTE - the order declared here is the order the items shows up in the drop-down

export const EVENT_GROUPING_TO_CID: Record<EventGroupingType, ContentId> = {
  [EventGroupingType.Performer]: ContentId.Performers,
  [EventGroupingType.Venue]: ContentId.Venues,
};

export const EVENT_SORT_TO_CID: Record<EventUiSort, ContentId> = {
  [EventUiSort.DateDesc]: ContentId.DateDescArrow,
  [EventUiSort.DateAsc]: ContentId.DateAscArrow,
  [EventUiSort.SortAtoZ]: ContentId.AtoZArrow,
  [EventUiSort.SortZtoA]: ContentId.ZtoAArrow,
};

export const EVENT_SORT_DATE_ONLY_TO_CID: Record<string, ContentId> = {
  [EventUiSort.DateDesc]: ContentId.DateDescArrow,
  [EventUiSort.DateAsc]: ContentId.DateAscArrow,
};

export const ON_SALE_EVENT_VIEW_MODE_TO_CID: Record<string, ContentId> = {
  [OnSaleEventViewMode.MetricView]: ContentId.InsightsView,
};
export const INVENTORY_VIEW_MODE_TO_CID: Record<string, ContentId> = {
  [InventoryViewMode.MetricView]: ContentId.InsightsView,
  [InventoryViewMode.FlattenedView]: ContentId.ListView,
  [InventoryViewMode.TileView]: ContentId.TileView,
};
export const SALES_VIEW_MODE_TO_CID: Record<string, ContentId> = {
  [SalesViewMode.FlattenedView]: ContentId.ListView,
  [SalesViewMode.TileView]: ContentId.TileView,
};
export const PURCHASE_VIEW_MODE_TO_CID: Record<string, ContentId> = {
  [PurchaseViewMode.EventTileView]: ContentId.EventView,
  [PurchaseViewMode.FlattenedView]: ContentId.ListView,
  [PurchaseViewMode.TileView]: ContentId.TimeView,
};

export const PURCHASE_SORT_TO_CID: Record<string, ContentId> = {
  [EventUiSort.DateDesc]: ContentId.DateDescArrow,
  [EventUiSort.DateAsc]: ContentId.DateAscArrow,
};

export const TIME_PERIOD_TO_CID: Record<
  Exclude<TimePeriodType, TimePeriodType.Daily>,
  ContentId
> = {
  // [TimePeriodType.Daily]: ContentId.Day, // TODO - Fix how we handle timezones when fetching data
  [TimePeriodType.Weekly]: ContentId.Week,
  [TimePeriodType.Monthly]: ContentId.Month,
};

export const CONVERSATION_SORT_TO_CID: Record<string, ContentId> = {
  [EventUiSort.DateDesc]: ContentId.DateDescArrow,
  [EventUiSort.DateAsc]: ContentId.DateAscArrow,
};

export const DEAL_CONFIG_SPLIT_TYPE_TO_CID: Record<string, ContentId> = {
  [DealSplitType.Sales]: ContentId.Sales,
  [DealSplitType.Quantity]: ContentId.Quantity,
  [DealSplitType.None]: ContentId.NoHurdle,
};

export const DEAL_CONFIG_TRESHOLD_SPLIT_DIRECTION_TO_CID: Record<
  string,
  ContentId
> = {
  [DealThresholdSplitDirection.Above]: ContentId.Above,
  [DealThresholdSplitDirection.Below]: ContentId.Below,
};

/**
 * Use `getSaleStatusDisplayContentId` for displaying purposes
 */
export const SALES_STATUS_TO_CID: Record<PointOfSaleSaleStatus, ContentId> = {
  [PointOfSaleSaleStatus.PendingConfirmation]: ContentId.PendingConfirmation,
  [PointOfSaleSaleStatus.PendingAllocation]: ContentId.PendingSourcing,
  [PointOfSaleSaleStatus.ProvisionalAllocation]:
    ContentId.ProvisionalAllocation,
  [PointOfSaleSaleStatus.PendingFulfillment]: ContentId.PendingFulfillment,
  [PointOfSaleSaleStatus.PendingReshipment]: ContentId.PendingReshipment,
  [PointOfSaleSaleStatus.ProcessingFulfillment]:
    ContentId.ProcessingFulfillment,
  [PointOfSaleSaleStatus.Fulfilled]: ContentId.Fulfilled,
  [PointOfSaleSaleStatus.FulfillmentFailed]: ContentId.FulfillmentFailed,
  [PointOfSaleSaleStatus.PendingRejection]: ContentId.Rejected,
  [PointOfSaleSaleStatus.Rejected]: ContentId.Cancelled,
  [PointOfSaleSaleStatus.Hold]: ContentId.Hold,
  [PointOfSaleSaleStatus.CancelledHold]: ContentId.CancelledHold,
  [PointOfSaleSaleStatus.Wasted]: ContentId.Wasted,
};

export const SETTINGS_VIEWS_TO_CONTENT_ID_MAP: Record<SettingTab, ContentId> = {
  [SettingTab.MyAccount]: ContentId.MyAccount,
  [SettingTab.UserManagement]: ContentId.UserManagement,
  [SettingTab.UserManagement_Users]: ContentId.Users,
  [SettingTab.UserManagement_Roles]: ContentId.Roles,
  [SettingTab.UserManagement_Teams]: ContentId.Teams,
  [SettingTab.SyncCenter]: ContentId.SyncCenter,
  [SettingTab.AutoPricing]: ContentId.Autopricing,
  [SettingTab.DialogSuppression]: ContentId.DialogSuppression,
  [SettingTab.EventDiscovery]: ContentId.EventDiscovery,
  [SettingTab.PurchaseOrder]: ContentId.Purchases,
  [SettingTab.Inventory]: ContentId.Inventory,
  [SettingTab.Accounting]: ContentId.Accounting,
  [SettingTab.SellerAccount]: ContentId.SellerAccount,
  [SettingTab.CurrencyConversion]: ContentId.CurrencyConversion,
  [SettingTab.FulfillmentProviders]: ContentId.FulfillmentProviders,
  [SettingTab.VendorManagement]: ContentId.VendorManagement,
  [SettingTab.VendorManagement_Payments]: ContentId.Payments,
  [SettingTab.VendorManagement_Vendors]: ContentId.Vendors,
  [SettingTab.CustomTabs]: ContentId.CustomTabs,
  [SettingTab.TaxRates]: ContentId.TaxRates,
};

export const SALE_PAYMENT_STATE_TO_CID: Record<
  PointOfSalePaymentState,
  ContentId
> = {
  [PointOfSalePaymentState.Paid]: ContentId.Paid,
  [PointOfSalePaymentState.Queued]: ContentId.QueuedForPayment,
  [PointOfSalePaymentState.Unpaid]: ContentId.Unpaid,
  [PointOfSalePaymentState.PartiallyPaid]: ContentId.PartiallyPaid,
  [PointOfSalePaymentState.PendingReversal]: ContentId.PendingReversal,
  [PointOfSalePaymentState.Reversed]: ContentId.Reversed,
};

export const SALE_CANCELLATION_REASON_CID: Record<
  SaleCancellationReason,
  ContentId
> = {
  [SaleCancellationReason.EventCancellation]: ContentId.EventCancellation,
  [SaleCancellationReason.SellerFault]: ContentId.SellerFault,
  [SaleCancellationReason.MarketplaceFault]: ContentId.MarketplaceFault,
  [SaleCancellationReason.NoFault]: ContentId.NoFault,
  [SaleCancellationReason.Other]: ContentId.Other,
};

export const MARKETPLACE_SALE_PAYMENT_STATE_TO_CID: Record<
  MarketplacePaymentState,
  ContentId
> = {
  [MarketplacePaymentState.Paid]: ContentId.Paid,
  [MarketplacePaymentState.Queued]: ContentId.QueuedForPayment,
  [MarketplacePaymentState.Unpaid]: ContentId.Unpaid,
  [MarketplacePaymentState.PartiallyPaid]: ContentId.PartiallyPaid,
  [MarketplacePaymentState.Ineligible]: ContentId.Ineligible,
  [MarketplacePaymentState.PendingReversal]: ContentId.PendingReversal,
  [MarketplacePaymentState.Reversed]: ContentId.Reversed,
};

export const MARKETPLACE_PAYMENT_LINE_TYPE_TO_CID: Record<
  MarketplacePaymentLineType,
  ContentId
> = {
  [MarketplacePaymentLineType.Credit]: ContentId.Credit,
  [MarketplacePaymentLineType.Proceeds]: ContentId.Proceeds,
  [MarketplacePaymentLineType.FullPrice]: ContentId.FullPrice,
  [MarketplacePaymentLineType.SellerFee]: ContentId.SellerFee,
  [MarketplacePaymentLineType.Penalty]: ContentId.Penalty,
  [MarketplacePaymentLineType.AlternativeTickets]: ContentId.AlternativeTickets,
  [MarketplacePaymentLineType.OrderNotFulfilled]: ContentId.OrderNotFulfilled,
  [MarketplacePaymentLineType.CancelledEvent]: ContentId.CancelledEvent,
  [MarketplacePaymentLineType.WitheldFunds]: ContentId.WitheldFunds,
  [MarketplacePaymentLineType.LastMinuteSalesLateDelivery]:
    ContentId.LastMinuteSalesLateDelivery,
  [MarketplacePaymentLineType.ExpiredShippingLabel]:
    ContentId.ExpiredShippingLabel,
  [MarketplacePaymentLineType.DeliveryMethodChange]:
    ContentId.DeliveryMethodChange,
  [MarketplacePaymentLineType.BuyerDeniedEntry]: ContentId.BuyerDeniedEntry,
  [MarketplacePaymentLineType.WrongTicketsReturnShippingCost]:
    ContentId.WrongTicketsReturnShippingCost,
  [MarketplacePaymentLineType.EarlyShippingLabelGeneration]:
    ContentId.EarlyShippingLabelGeneration,
  [MarketplacePaymentLineType.WrongTrackingNumber]:
    ContentId.WrongTrackingNumber,
  [MarketplacePaymentLineType.ExcessiveFailureRate]:
    ContentId.ExcessiveFailureRate,
  [MarketplacePaymentLineType.SellerError]: ContentId.SellerError,
  [MarketplacePaymentLineType.AlternativeTicketsBuyerCompensation]:
    ContentId.AlternativeTicketsBuyerCompensation,
  [MarketplacePaymentLineType.RAGSellerFaultNoResponse]:
    ContentId.RAGSellerFaultNoResponse,
  [MarketplacePaymentLineType.OverchargedSeller]: ContentId.OverchargedSeller,
  [MarketplacePaymentLineType.ShippingRefund]: ContentId.ShippingRefund,
  [MarketplacePaymentLineType.SellerRelationship]: ContentId.SellerRelationship,
  [MarketplacePaymentLineType.RAGDeliveryDispute]: ContentId.RAGDeliveryDispute,
  [MarketplacePaymentLineType.CSError]: ContentId.CSError,
  [MarketplacePaymentLineType.LMSError]: ContentId.LMSError,
  [MarketplacePaymentLineType.TaxRefund]: ContentId.TaxRefund,
  [MarketplacePaymentLineType.Other]: ContentId.Other,
  [MarketplacePaymentLineType.Charge]: ContentId.Charge,
  [MarketplacePaymentLineType.CancelledProceeds]: ContentId.CancelledProceeds,
  [MarketplacePaymentLineType.Tax]: ContentId.Tax,
};

export const CONFIRMATION_DIALOG_TYPE_TO_CID: Record<
  ConfirmationDialogType,
  {
    title: ContentId;
    description: ContentId;
  }
> = {
  [ConfirmationDialogType.FloorCeilingViolation]: {
    title: ContentId.FloorCeilingViolation,
    description: ContentId.FloorCeilingViolationDescription,
  },
  [ConfirmationDialogType.SuspiciousPriceChange]: {
    title: ContentId.SuspiciousPriceChange,
    description: ContentId.SuspiciousPriceChangeDescription,
  },
  [ConfirmationDialogType.AutoPricingDisable]: {
    title: ContentId.AutoPricingDisable,
    description: ContentId.AutoPricingDisableDescription,
  },
  [ConfirmationDialogType.AbsolutePriceDrop]: {
    title: ContentId.AbsolutePriceDrop,
    description: ContentId.AbsolutePriceDropDescription,
  },
  [ConfirmationDialogType.RelativePriceDrop]: {
    title: ContentId.RelativePriceDrop,
    description: ContentId.RelativePriceDropDescription,
  },
  [ConfirmationDialogType.RelativeFloorPriceDrop]: {
    title: ContentId.RelativeFloorPriceDrop,
    description: ContentId.RelativeFloorPriceDropDescription,
  },
  [ConfirmationDialogType.PriceStaggerFloorPriceDrop]: {
    title: ContentId.PriceStaggerFloorPriceDialog,
    description: ContentId.PriceStaggerFloorPriceDropDescription,
  },
};

export const MARKETPLACE_PAYMENT_LINE_V2_TYPE_TO_CID: Record<
  | MarketplacePaymentLineType.Credit
  | MarketplacePaymentLineType.Proceeds
  | MarketplacePaymentLineType.Charge,
  ContentId
> = {
  [MarketplacePaymentLineType.Credit]: ContentId.Credit,
  [MarketplacePaymentLineType.Proceeds]: ContentId.Proceeds,
  [MarketplacePaymentLineType.Charge]: ContentId.Charge,
};

export const PURCHASE_PAYMENT_STATUS_TO_CID: Record<
  PurchasePaymentStatus,
  ContentId
> = {
  [PurchasePaymentStatus.Unpaid]: ContentId.Unpaid,
  [PurchasePaymentStatus.PartiallyPaid]: ContentId.PartiallyPaid,
  [PurchasePaymentStatus.Paid]: ContentId.Paid,
  [PurchasePaymentStatus.Failed]: ContentId.Failed,
  [PurchasePaymentStatus.RefundNeeded]: ContentId.RefundNeeded,
  [PurchasePaymentStatus.Refunded]: ContentId.Refunded,
  [PurchasePaymentStatus.PartiallyRefunded]: ContentId.PartiallyRefunded,
};

export const QUALITY_CONTROL_STATE_TO_CID: Record<
  QualityControlState,
  ContentId
> = {
  [QualityControlState.Pending]: ContentId.Pending,
  [QualityControlState.Approved]: ContentId.Approved,
  [QualityControlState.Rejected]: ContentId.Rejected,
};

export const ROLE_TO_CID: Record<Role, [ContentId, ContentId]> = {
  [Role.Owner]: [ContentId.Owner, ContentId.Role_Owner_Details],
  [Role.Buyer]: [ContentId.Buyer, ContentId.Role_Buyer_Details],
  [Role.Finance]: [ContentId.Finance, ContentId.Role_Finance_Details],
  [Role.FinanceAPI]: [ContentId.FinanceAPI, ContentId.Role_FinanceAPI_Details],
  [Role.Fulfillment]: [
    ContentId.Fulfillment,
    ContentId.Role_Fulfillment_Details,
  ],
  [Role.Pricer]: [ContentId.Pricer, ContentId.Role_Pricer_Details],
  [Role.Processor]: [ContentId.Processor, ContentId.Role_Processor_Details],
  [Role.AutoPO]: [ContentId.AutoPO, ContentId.Role_AutoPO_Details],
  [Role.AutoFulfill]: [
    ContentId.AutoFulfill,
    ContentId.Role_AutoFulfill_Details,
  ],
  [Role.AutoPricer]: [ContentId.AutoPricer, ContentId.Role_AutoPricer_Details],
  [Role.Reporter]: [ContentId.Reporter, ContentId.Role_Reporter_Details],
};

export const PERMISSION_ACCESS_AREA_TO_CID: Record<
  PermissionAccessArea,
  ContentId
> = {
  [PermissionAccessArea.General]: ContentId.General,
  [PermissionAccessArea.Inventory]: ContentId.Inventory,
  [PermissionAccessArea.Sales]: ContentId.Sales,
  [PermissionAccessArea.Purchases]: ContentId.Purchases,
  [PermissionAccessArea.Events]: ContentId.Events,
  [PermissionAccessArea.Account]: ContentId.Account,
  [PermissionAccessArea.Reporting]: ContentId.Reporting,
  [PermissionAccessArea.Messages]: ContentId.Messages,
  [PermissionAccessArea.Accounting]: ContentId.Accounting,
  [PermissionAccessArea.AdPlatform]: ContentId.SponsoredListings,
};

export const PERMISSION_TO_CID: Record<
  Permission,
  // TODO - add contentId for Details (explanation when clicking (i) icon)
  [ContentId, ContentId, 'view' | 'action']
> = {
  [Permission.Sales_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Sales_ViewAll_Details,
    'view',
  ],
  [Permission.Sales_ViewRecent]: [
    ContentId.Permission_ViewRecentSales,
    ContentId.Sales_ViewRecent_Details,
    'view',
  ],
  [Permission.Sales_ViewRecentFromExternalMarketplace]: [
    ContentId.Permission_ViewRecentFromExternalMarketplace,
    ContentId.Sales_ViewRecentFromExternalMarketplace_Details,
    'view',
  ],
  [Permission.Sales_ConfirmReject]: [
    ContentId.Permission_ConfirmRejectSale,
    ContentId.Sales_ConfirmReject_Details,
    'action',
  ],
  [Permission.Sales_Fulfill]: [
    ContentId.Permission_FulfillSale,
    ContentId.Sales_Fulfill_Details,
    'action',
  ],
  [Permission.Sales_CreateForExternalMarketplaces]: [
    ContentId.Permission_CreateForExternalMarketplaces,
    ContentId.Sales_CreateForExternalMarketplaces_Details,
    'action',
  ],
  [Permission.Sales_ViewProceeds]: [
    ContentId.Permission_ViewProceeds,
    ContentId.Sales_ViewProceeds_Details,
    'view',
  ],
  [Permission.Sales_ViewRecentProceeds]: [
    ContentId.Permission_ViewRecentProceeds,
    ContentId.Sales_ViewRecentProceeds_Details,
    'view',
  ],
  [Permission.Sales_ViewCostAndMargin]: [
    ContentId.Permission_ViewCostAndMargin,
    ContentId.Sales_ViewCostAndMargin_Details,
    'view',
  ],
  [Permission.Sales_ViewPaymentState]: [
    ContentId.Permission_ViewPaymentState,
    ContentId.Sales_ViewPaymentState_Details,
    'view',
  ],
  [Permission.Sales_ViewFulfillmentArtifacts]: [
    ContentId.Permission_ViewFulfillmentArtifacts,
    ContentId.Sales_ViewFulfillmentArtifacts_Details,
    'view',
  ],
  [Permission.Sales_ManageHold]: [
    ContentId.Permission_ManageHolds,
    ContentId.Sales_ManageHold_Details,
    'action',
  ],
  [Permission.Sales_ViewHomePageMetrics]: [
    ContentId.Permission_ViewHomePageMetrics,
    ContentId.Permission_ViewHomePageMetrics_Details,
    'view',
  ],
  [Permission.Inventory_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Inventory_ViewAll_Details,
    'view',
  ],
  [Permission.Inventory_ViewRecent]: [
    ContentId.Permission_ViewRecentListings,
    ContentId.Inventory_ViewRecent_Details,
    'view',
  ],
  [Permission.Inventory_ViewRecentFromExternalMarketplace]: [
    ContentId.Permission_ViewRecentFromExternalMarketplace,
    ContentId.Inventory_ViewRecentFromExternalMarketplace_Details,
    'view',
  ],
  [Permission.Inventory_ViewAllMarketplaceAttributes]: [
    ContentId.Permission_ViewAllMarketplaceAttributes,
    ContentId.Inventory_ViewAllMarketplaceAttributes_Details,
    'view',
  ],
  [Permission.Inventory_ViewExternalMarketplaceAttributes]: [
    ContentId.Permission_ViewExternalMarketplaceAttributes,
    ContentId.Inventory_ViewExternalMarketplaceAttributes_Details,
    'view',
  ],
  [Permission.Inventory_ViewFulfillmentArtifacts]: [
    ContentId.Permission_ViewFulfillmentArtifacts,
    ContentId.Inventory_ViewFulfillmentArtifacts_Details,
    'view',
  ],
  [Permission.Inventory_SetPrice]: [
    ContentId.Permission_SetPrice,
    ContentId.Inventory_SetPrice_Details,
    'action',
  ],
  [Permission.Inventory_SetPriceOnPurchasedBy]: [
    ContentId.Permission_SetPriceOnPurchasedListings,
    ContentId.Inventory_SetPriceOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_SetPriceOnIsPricerOf]: [
    ContentId.Permission_SetPriceOnAssignedListings,
    ContentId.Inventory_SetPriceOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Inventory_Predelivery]: [
    ContentId.Permission_Predeliver,
    ContentId.Inventory_Predelivery_Details,
    'action',
  ],
  [Permission.Inventory_BroadcastUnbroadcast]: [
    ContentId.Permission_BroadcastUnbroadcast,
    ContentId.Inventory_BroadcastUnbroadcast_Details,

    'action',
  ],
  [Permission.Inventory_BroadcastUnbroadcastOnPurchasedBy]: [
    ContentId.Permission_BroadcastUnbroadcastOnPurchasedBy,
    ContentId.Inventory_BroadcastUnbroadcastOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_UpdateListingInfo]: [
    ContentId.Permission_UpdateInfo,
    ContentId.Inventory_UpdateListingInfo_Details,
    'action',
  ],
  [Permission.Inventory_UpdateListingInfoOnPurchasedBy]: [
    ContentId.Permission_UpdateInfoOnPurchasedListings,
    ContentId.Inventory_UpdateListingInfoOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_UpdateDeliveryStrategy]: [
    ContentId.Permission_UpdateDeliveryStrategy,
    ContentId.Inventory_UpdateDeliveryStrategy_Details,
    'action',
  ],
  [Permission.Inventory_UpdateDeliveryStrategyOnIsPricerOf]: [
    ContentId.Permission_UpdateDeliveryStrategyOnPricedListings,
    ContentId.Inventory_UpdateDeliveryStrategyOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Inventory_UpdateDeliveryStrategyOnPurchasedBy]: [
    ContentId.Permission_UpdateDeliveryStrategyOnPurchasedListings,
    ContentId.Inventory_UpdateDeliveryStrategyOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_ManageAdminHolds]: [
    ContentId.Permission_ManageAdminHold,
    ContentId.Inventory_ManageAdminHold_Details,
    'action',
  ],
  [Permission.SellerAccount_Admin]: [
    ContentId.Permission_Administration,
    ContentId.SellerAccount_Admin_Details,
    'action',
  ],
  [Permission.SellerSupportCase_Create]: [
    ContentId.Permission_Create,
    ContentId.SellerSupportCase_Create_Details,
    'action',
  ],
  [Permission.SellerSupportCase_View]: [
    ContentId.Permission_ViewAll,
    ContentId.SellerSupportCase_View_Details,
    'view',
  ],
  [Permission.Purchases_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Purchases_ViewAll_Details,
    'view',
  ],
  [Permission.Purchases_ViewRecent]: [
    ContentId.Permission_ViewRecent,
    ContentId.Purchases_ViewRecent_Details,
    'view',
  ],
  [Permission.Purchases_B2B_View]: [
    ContentId.Permission_ViewB2B,
    ContentId.Purchases_B2B_View_Details,
    'view',
  ],
  [Permission.Purchases_Edit]: [
    ContentId.Permission_UpdateInfo,
    ContentId.Purchases_Edit_Details,
    'action',
  ],
  [Permission.Purchases_EditOwned]: [
    ContentId.Permission_UpdateInfoOnPurchasedListings,
    ContentId.Purchases_EditOwned_Details,
    'action',
  ],
  [Permission.Purchases_B2B_Update]: [
    ContentId.Permission_UpdateB2B,
    ContentId.Purchases_B2B_Update_Details,
    'action',
  ],
  [Permission.Purchases_UpdateBuyerCommission]: [
    ContentId.Permission_UpdateBuyerCommission,
    ContentId.Purchases_UpdateBuyerCommission_Details,
    'action',
  ],
  [Permission.Purchases_UpdateBuyerCommissionOwned]: [
    ContentId.Permission_UpdateBuyerCommissionOwned,
    ContentId.Purchases_UpdateBuyerCommissionOwned_Details,
    'action',
  ],
  [Permission.Purchases_UpdateDeliveryType]: [
    ContentId.Permission_UpdateDeliveryType,
    ContentId.Purchases_UpdateDeliveryType_Details,
    'action',
  ],
  [Permission.Purchases_UpdateDeliveryTypeOwned]: [
    ContentId.Permission_UpdateDeliveryTypeOwned,
    ContentId.Purchases_UpdateDeliveryTypeOwned_Details,
    'action',
  ],
  [Permission.Purchases_UpdateCustomDeliveryType]: [
    ContentId.Permission_UpdateCustomDeliveryType,
    ContentId.Purchases_UpdateCustomDeliveryType_Details,
    'action',
  ],
  [Permission.Purchases_UpdateCustomDeliveryTypeOwned]: [
    ContentId.Permission_UpdateCustomDeliveryTypeOwned,
    ContentId.Purchases_UpdateCustomDeliveryTypeOwned_Details,
    'action',
  ],
  [Permission.Purchases_UpdateSeatTraits]: [
    ContentId.Permission_UpdateSeatTraits,
    ContentId.Purchases_UpdateSeatTraits_Details,
    'action',
  ],
  [Permission.Purchases_UpdateSeatTraitsOwned]: [
    ContentId.Permission_UpdateSeatTraitsOwned,
    ContentId.Purchases_UpdateSeatTraitsOwned_Details,
    'action',
  ],
  [Permission.Purchases_Create]: [
    ContentId.Permission_CreatePO,
    ContentId.Purchases_Create_Details,
    'action',
  ],
  [Permission.Purchases_LockUnlockCommission]: [
    ContentId.Permission_LockUnlockCommission,
    ContentId.Purchases_LockUnlockCommission_Details,
    'action',
  ],
  [Permission.Purchases_LockUnlockCommissionOwned]: [
    ContentId.Permission_LockUnlockCommissionOwned,
    ContentId.Purchases_LockUnlockCommissionOwned_Details,
    'action',
  ],
  [Permission.Purchases_EditVendor]: [
    ContentId.Permission_EditVendor,
    ContentId.Purchases_EditVendor_Details,
    'action',
  ],
  [Permission.Events_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Events_ViewAll_Details,
    'view',
  ],
  [Permission.Accounts_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Accounts_ViewAll_Details,
    'view',
  ],
  [Permission.TicketGroups_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.TicketGroups_ViewAll_Details,
    'view',
  ],
  [Permission.Sales_AddTagType]: [
    ContentId.Permission_AddTagType,
    ContentId.Sales_AddTagType_Details,
    'action',
  ],
  [Permission.Sales_UpdateTags]: [
    ContentId.Permission_UpdateTags,
    ContentId.Sales_UpdateTags_Details,
    'action',
  ],
  [Permission.Sales_ViewSalesOnIsPricerOf]: [
    ContentId.Permission_ViewSaleFromPricedListings,
    ContentId.Sales_ViewSalesOnIsPricerOf_Details,
    'view',
  ],
  [Permission.Sales_UpdateSalesInfo]: [
    ContentId.Permission_UpdateInfo,
    ContentId.Sales_UpdateSalesInfo_Details,
    'action',
  ],
  [Permission.Sales_UpdateSalesInfoOnIsPricerOf]: [
    ContentId.Permission_UpdateInfoOnPricedListings,
    ContentId.Sales_UpdateSalesInfoOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Sales_UpdateSalesInfoOnIsFulfillerOf]: [
    ContentId.Permission_UpdateInfoOnAssignedSales,
    ContentId.Sales_UpdateSalesInfoOnIsFulfillerOf_Details,
    'action',
  ],
  [Permission.Sales_FulfillOnIsFulfillerOf]: [
    ContentId.Permission_FulfillSalesOnAssignedSales,
    ContentId.Sales_FulfillOnIsFulfillerOf_Details,
    'action',
  ],
  [Permission.Sales_ViewSalesOnPurchasedBy]: [
    ContentId.Permission_ViewSaleOnPurchasedListings,
    ContentId.Sales_ViewSalesOnPurchasedBy_Details,
    'view',
  ],
  [Permission.Sales_UpdateSaleOnPurchasedBy]: [
    ContentId.Permission_UpdateInfoFromPurchasedListings,
    ContentId.Sales_UpdateSaleOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Sales_FulfillOnPurchasedBy]: [
    ContentId.Permission_FulfillSalesFromPurchasedListings,
    ContentId.Sales_FulfillOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Sales_FulfillOnPricerOf]: [
    ContentId.Permission_FulfillSaleOnPricedListings,
    ContentId.Sales_FulfillOnPricerOf_Details,
    'action',
  ],
  [Permission.Sales_UpdateTagsOnPurchasedBy]: [
    ContentId.Permission_UpdateTagsFromPurchasedListings,
    ContentId.Sales_UpdateTagsOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Sales_UpdateTagsOnIsPricerOf]: [
    ContentId.Permission_UpdateTagsFromPricedListings,
    ContentId.Sales_UpdateTagsOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Sales_UpdateTagsOnIsFulfillerOf]: [
    ContentId.Permission_UpdateTagsOnAssignedSales,
    ContentId.Sales_UpdateTagsOnIsFulfillerOf_Details,
    'action',
  ],
  [Permission.Sales_ConfirmRejectOnIsPricerOf]: [
    ContentId.Permission_ConfirmRejectSaleOnPricedListings,
    ContentId.Sales_ConfirmRejectOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Sales_ConfirmRejectOnPurchasedBy]: [
    ContentId.Permission_ConfirmRejectSalesFromPurchasedListings,
    ContentId.Sales_ConfirmRejectOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Sales_ViewFulfillmentArtifactsOnPurchasedBy]: [
    ContentId.Permission_ViewFulfillmentArtifactsOnSaleFromPurchasedListings,
    ContentId.Sales_ViewFulfillmentArtifactsOnPurchasedBy_Details,
    'view',
  ],
  [Permission.Sales_ViewFulfillmentArtifactsOnIsPricerOf]: [
    ContentId.Permission_ViewFulfillmentArtifactsOnSaleFromPricedListings,
    ContentId.Sales_ViewFulfillmentArtifactsOnIsPricerOf_Details,
    'view',
  ],
  [Permission.Sales_ConfirmRejectOnIsFulfillerOf]: [
    ContentId.Permission_ConfirmRejectOnAssignedSales,
    ContentId.Sales_ConfirmRejectOnIsFulfillerOf_Details,
    'action',
  ],
  [Permission.Sales_ViewSalesOnIsFulfillerOf]: [
    ContentId.Permission_ViewAssignedSales,
    ContentId.Sales_ViewSalesOnIsFulfillerOf_Details,
    'view',
  ],
  [Permission.Inventory_EditPricing]: [
    ContentId.Permission_SetPrice,
    ContentId.Inventory_EditPricing_Details,
    'action',
  ],
  [Permission.Inventory_AddTagType]: [
    ContentId.Permission_AddTagType,
    ContentId.Inventory_AddTagType_Details,
    'action',
  ],
  [Permission.Inventory_UpdateTags]: [
    ContentId.Permission_UpdateTags,
    ContentId.Inventory_UpdateTags_Details,
    'action',
  ],
  [Permission.Inventory_UpdateTagsOnPurchasedBy]: [
    ContentId.Permission_UpdateTagsOnPurchasedListings,
    ContentId.Inventory_UpdateTagsOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_ViewListingOnIsPricerOf]: [
    ContentId.Permission_ViewAssignedListings,
    ContentId.Inventory_ViewListingOnIsPricerOf_Details,
    'view',
  ],
  [Permission.Inventory_UpdateListingInfoOnIsPricerOf]: [
    ContentId.Permission_UpdateInfoOnAssignedListings,
    ContentId.Inventory_UpdateListingInfoOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Inventory_UpdateTagsOnIsPricerOf]: [
    ContentId.Permission_UpdateTagsOnAssignedListings,
    ContentId.Inventory_UpdateTagsOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Inventory_PredeliveryOnPurchasedBy]: [
    ContentId.Permission_PredeliverPurchasedListings,
    ContentId.Inventory_PredeliveryOnPurchasedBy_Details,
    'action',
  ],
  [Permission.Inventory_PredeliveryOnIsPricerOf]: [
    ContentId.Permission_PredeliverOnAssignedListings,
    ContentId.Inventory_PredeliveryOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Inventory_ViewListingsOnPurchasedBy]: [
    ContentId.Permission_ViewPurchasedListings,
    ContentId.Inventory_ViewListingsOnPurchasedBy_Details,
    'view',
  ],
  [Permission.Inventory_ViewFulfillmentArtifactsOnPurchasedBy]: [
    ContentId.Permission_ViewFulfillmentArtifactsOnPurchasedListings,
    ContentId.Inventory_ViewFulfillmentArtifactsOnPurchasedBy_Details,
    'view',
  ],
  [Permission.Inventory_ViewFulfillmentArtifactsOnIsPricerOf]: [
    ContentId.Permission_ViewFulfillmentArtifactsOnAssignedListings,
    ContentId.Inventory_ViewFulfillmentArtifactsOnIsPricerOf_Details,
    'view',
  ],
  [Permission.Inventory_BroadcastUnbroadcastOnIsPricerOf]: [
    ContentId.Permission_BroadcastUnbroadcastOnAssignedListings,
    ContentId.Inventory_BroadcastUnbroadcastOnIsPricerOf_Details,
    'action',
  ],
  [Permission.Purchases_AddTagType]: [
    ContentId.Permission_AddTagType,
    ContentId.Purchases_AddTagType_Details,
    'action',
  ],
  [Permission.Purchases_UpdateTags]: [
    ContentId.Permission_UpdateTags,
    ContentId.Purchases_UpdateTags_Details,
    'action',
  ],
  [Permission.Purchases_UpdateTagsOwned]: [
    ContentId.Permission_UpdateTagsOnOwnedPurchasedOrder,
    ContentId.Purchases_UpdateTagsOwned_Details,
    'action',
  ],
  [Permission.Purchases_ViewOwned]: [
    ContentId.Permission_ViewOwnedPurchasedOrders,
    ContentId.Purchases_ViewOwned_Details,
    'view',
  ],
  [Permission.Events_AddTagType]: [
    ContentId.Permission_AddTagType,
    ContentId.Events_AddTagType_Details,
    'action',
  ],
  [Permission.Events_UpdateTags]: [
    ContentId.Permission_UpdateTags,
    ContentId.Events_UpdateTags_Details,
    'action',
  ],
  [Permission.Events_Edit]: [
    ContentId.Permission_UpdateInfo,
    ContentId.Events_Edit_Details,
    'action',
  ],
  [Permission.Events_ManageEventDiscovery]: [
    ContentId.Permission_UnlockEventDiscovery,
    ContentId.Permission_UnlockEventDiscoveryDescription,
    'action',
  ],
  [Permission.Events_TeamPricing]: [
    ContentId.Permission_EventTeamPricing,
    ContentId.Permission_EventTeamPricingDescription,
    'action',
  ],
  [Permission.Reports_CreateReports]: [
    ContentId.Permission_CreateReports,
    ContentId.Reports_CreateReports_Details,
    'action',
  ],
  [Permission.Reports_UpdateReports]: [
    ContentId.Permission_UpdateReports,
    ContentId.Reports_UpdateReports_Details,
    'action',
  ],
  [Permission.Reports_UpdateReportsOwned]: [
    ContentId.Permission_UpdateCreatedReports,
    ContentId.Reports_UpdateReportsOwned_Details,
    'action',
  ],
  [Permission.Reports_ViewInventoryReports]: [
    ContentId.Permission_ViewInventoryReports,
    ContentId.Reports_ViewInventoryReports_Details,
    'view',
  ],
  [Permission.Reports_ViewSalesReports]: [
    ContentId.Permission_ViewSalesReports,
    ContentId.Reports_ViewSalesReports_Details,
    'view',
  ],
  [Permission.Reports_ViewGlobalReports]: [
    ContentId.Permission_ViewGlobalReports,
    ContentId.Reports_ViewGlobalReports_Details,
    'view',
  ],
  [Permission.Reports_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Reports_ViewAll_Details,
    'view',
  ],
  [Permission.Reports_ViewSharedReports]: [
    ContentId.Permission_ViewSharedReports,
    ContentId.Reports_ViewSharedReports_Details,
    'view',
  ],
  [Permission.Sales_ViewFulfillmentArtifactsOnIsFulfillerOf]: [
    ContentId.Permission_ViewFulfillmentArtifactsOnAssignedSales,
    ContentId.Sales_ViewFulfillmentArtifactsOnIsFulfillerOf_Details,
    'view',
  ],
  [Permission.Sales_CreateOfflineSale]: [
    ContentId.Permission_CreateOfflineSale,
    ContentId.Sales_CreateOfflineSale_Details,
    'action',
  ],
  [Permission.Sales_ManageOfflineSale]: [
    ContentId.Permission_ManageOfflineSale,
    ContentId.Sales_ManageOfflineSale_Details,
    'action',
  ],
  [Permission.Sales_CreateDonationSale]: [
    ContentId.Permission_CreateDonationSale,
    ContentId.Sales_CreateDonationSale_Details,
    'action',
  ],
  [Permission.Sales_ManageDonationSale]: [
    ContentId.Permission_ManageDonationSale,
    ContentId.Sales_ManageDonationSale_Details,
    'action',
  ],
  [Permission.Sales_ManageOfflineSaleCreatedBy]: [
    ContentId.Permission_ManageOfflineSalesOnPurchasedListings,
    ContentId.Sales_ManageOfflineSaleCreatedBy_Details,
    'action',
  ],
  [Permission.Sales_ConfirmTransferWithoutProof]: [
    ContentId.Permission_ConfirmTransferWithoutProof,
    ContentId.Sales_ConfirmTransferWithoutProof_Details,
    'action',
  ],
  [Permission.Sales_ResetFulfillment]: [
    ContentId.Permission_ResetFulfillment,
    ContentId.Sales_ResetFulfillment_Details,
    'action',
  ],
  [Permission.Inventory_AddSeatSaver]: [
    ContentId.Permission_AddSeatSaver,
    ContentId.Inventory_AddSeatSaver_Details,
    'action',
  ],
  [Permission.Inventory_ManageSeatSaver]: [
    ContentId.Permission_ManagePlaceholderListings,
    ContentId.Inventory_ManageSeatSaver_Details,
    'action',
  ],
  [Permission.Inventory_ManageSeatSaverCreatedBy]: [
    ContentId.Permission_ManageCreatedPlaceholderListings,
    ContentId.Inventory_ManageSeatSaverCreatedBy_Details,
    'action',
  ],
  [Permission.Events_SetPrice]: [
    ContentId.Permission_ConfigurePricing,
    ContentId.Events_SetPrice_Details,
    'action',
  ],
  [Permission.Account_SetPrice]: [
    ContentId.Permission_ConfigurePricing,
    ContentId.Account_SetPrice_Details,
    'action',
  ],
  [Permission.Webhook_View]: [
    ContentId.Permission_Webhook_View,
    ContentId.Webhook_View_Details,
    'view',
  ],
  [Permission.Webhook_Create]: [
    ContentId.Permission_Webhook_Create,
    ContentId.Webhook_Create_Details,
    'action',
  ],
  [Permission.Webhook_Edit]: [
    ContentId.Permission_Webhook_Edit,
    ContentId.Webhook_Edit_Details,
    'action',
  ],
  [Permission.EventConfig_Create]: [
    ContentId.Permission_EventConfig_Create,
    ContentId.EventConfig_Create_Details,
    'action',
  ],
  [Permission.EventConfig_Edit]: [
    ContentId.Permission_EventConfig_Edit,
    ContentId.EventConfig_Edit_Details,
    'action',
  ],
  [Permission.EventConfig_View]: [
    ContentId.Permission_EventConfig_View,
    ContentId.EventConfig_View_Details,
    'view',
  ],
  [Permission.Accounting_ViewAll]: [
    ContentId.Permission_ViewAll,
    ContentId.Accounting_ViewAll_Details,
    'view',
  ],
  [Permission.Accounting_ViewPaymentsOnSale]: [
    ContentId.Permission_ViewPaymentsOnSale,
    ContentId.Accounting_ViewPaymentsOnSale_Details,
    'view',
  ],
  [Permission.Accounting_ViewStubhubPayments]: [
    ContentId.Permission_ViewStubhubPayments,
    ContentId.Accounting_ViewStubhubPayments_Details,
    'view',
  ],
  [Permission.Accounting_ViewAutoPricingSettings]: [
    ContentId.Permission_ViewAutoPricingSettings,
    ContentId.Accounting_ViewAutoPricingSettings_Details,
    'view',
  ],
  [Permission.General_ViewNotifications]: [
    ContentId.Permission_ViewNotifications,
    ContentId.General_ViewNotifications_Details,
    'view',
  ],
  [Permission.General_ViewReleaseNotes]: [
    ContentId.Permission_ViewReleaseNotes,
    ContentId.General_ViewReleaseNotes_Details,
    'view',
  ],
  [Permission.General_ViewHelpCenter]: [
    ContentId.Permission_ViewHelpCenter,
    ContentId.General_ViewHelpCenter_Details,
    'view',
  ],
  [Permission.AdPlatform_Edit]: [
    ContentId.Permission_AdPlatformEdit,
    ContentId.AdPlatform_Edit_Details,
    'action',
  ],
  [Permission.Inventory_Export]: [
    ContentId.Permission_Inventory_Export,
    ContentId.Inventory_Export_Details,
    'action',
  ],
  [Permission.Sales_Export]: [
    ContentId.Permission_Sales_Export,
    ContentId.Inventory_Export_Details,
    'action',
  ],
  [Permission.Purchases_Export]: [
    ContentId.Permission_Purchases_Export,
    ContentId.Purchases_Export_Details,
    'action',
  ],
  [Permission.Inventory_ViewColumnTotals]: [
    ContentId.Permission_ViewInventoryColumnTotals,
    ContentId.Inventory_ViewInventoryColumnTotals_Details,
    'view',
  ],
  [Permission.Sales_ViewColumnTotals]: [
    ContentId.Permission_ViewSaleColumnTotals,
    ContentId.Sale_ViewSaleColumnTotals_Details,
    'view',
  ],
  [Permission.Purchases_ViewColumnTotals]: [
    ContentId.Permission_ViewPurchaseColumnTotals,
    ContentId.Purchase_ViewPurchaseColumnTotals_Details,
    'view',
  ],
  [Permission.AdPlatform_CampaignsViewAll]: [
    ContentId.AdPlatform_CampaignsViewAll,
    ContentId.Permission_AdPlatform_CampaignsViewAll,
    'view',
  ],
  [Permission.AdPlatform_CampaignsCreate]: [
    ContentId.AdPlatform_CampaignsCreate,
    ContentId.Permission_AdPlatform_CampaignsCreate,
    'action',
  ],
  [Permission.AdPlatform_CampaignsEdit]: [
    ContentId.AdPlatform_CampaignsEdit,
    ContentId.Permission_AdPlatform_CampaignsEdit,
    'action',
  ],
  [Permission.Purchases_ManagePaymentMethod]: [
    ContentId.Purchases_ManagePaymentMethod,
    ContentId.Permission_Purchases_ManagePaymentMethod,
    'action',
  ],
  [Permission.Purchases_ManageTeamVendors]: [
    ContentId.Purchases_ManageTeamVendors,
    ContentId.Permission_Purchases_ManageTeamVendors,
    'action',
  ],
  [Permission.Purchases_ManageTeamPurchasedBy]: [
    ContentId.Purchases_ManageTeamPurchasedBy,
    ContentId.Permission_Purchases_ManageTeamPurchasedBy,
    'action',
  ],
};

export const EVENT_TIME_FRAME_FILTER_TO_CID: Record<
  EventTimeFrameFilter,
  ContentId
> = {
  [EventTimeFrameFilter.Future]: ContentId.FutureEvents,
  [EventTimeFrameFilter.Past]: ContentId.PastEvents,
};

export const MARKETPLACE_PAYMENTS_TIME_FRAME_FILTER_TO_CID: Record<
  EventTimeFrameFilter,
  ContentId
> = {
  [EventTimeFrameFilter.Future]: ContentId.FuturePayments,
  [EventTimeFrameFilter.Past]: ContentId.PastPayments,
};

export const TOP_LEVEL_CATEGORY_TO_CID: Record<TopLevelCategory, ContentId> = {
  [TopLevelCategory.Concert]: ContentId.Concert,
  [TopLevelCategory.Festival]: ContentId.Festival,
  [TopLevelCategory.Sports]: ContentId.Sports,
  [TopLevelCategory.Theatre]: ContentId.Theatre,
};

export const PARENT_CATEGORY_TO_CID: Record<string, ContentId> = {
  '1007': ContentId.Category1007,
  '1009': ContentId.Category1009,
  '4286': ContentId.Category4286,
  '5099': ContentId.Category5099,
  '6401': ContentId.Category6401,
  '6404': ContentId.Category6404,
  '6451': ContentId.Category6451,
  '6452': ContentId.Category6452,
  '12567': ContentId.Category12567,
  '263024': ContentId.Category263024,
  '272988': ContentId.Category272988,
  '272989': ContentId.Category272989,
  '273013': ContentId.Category273013,
  '273026': ContentId.Category273026,
  '273031': ContentId.Category273031,
  '273034': ContentId.Category273034,
  '273055': ContentId.Category273055,
  '273057': ContentId.Category273057,
  '273089': ContentId.Category273089,
  '273137': ContentId.Category273137,
  '273138': ContentId.Category273138,
  '273164': ContentId.Category273164,
  '273171': ContentId.Category273171,
  '273393': ContentId.Category273393,
  '273409': ContentId.Category273409,
  '273431': ContentId.Category273431,
  '273485': ContentId.Category273485,
  '273529': ContentId.Category273529,
  '273657': ContentId.Category273657,
  '274164': ContentId.Category274164,
  '274701': ContentId.Category274701,
  '274794': ContentId.Category274794,
  '275344': ContentId.Category275344,
  '275641': ContentId.Category275641,
  '276077': ContentId.Category276077,
  '276281': ContentId.Category276281,
  '276306': ContentId.Category276306,
  '276308': ContentId.Category276308,
  '276311': ContentId.Category276311,
  '276861': ContentId.Category276861,
  '278221': ContentId.Category278221,
  '278837': ContentId.Category278837,
  '279267': ContentId.Category279267,
  '279563': ContentId.Category279563,
  '289352': ContentId.Category289352,
  '150012246': ContentId.Category150012246,
  '1013': ContentId.Category1013,
  '1015': ContentId.Category1015,
  '1017': ContentId.Category1017,
  '2294': ContentId.Category2294,
  '4551': ContentId.Category4551,
  '6403': ContentId.Category6403,
  '55548': ContentId.Category55548,
  '259716': ContentId.Category259716,
  '356361': ContentId.Category356361,
  '356453': ContentId.Category356453,
  '356499': ContentId.Category356499,
  '356585': ContentId.Category356585,
  '357019': ContentId.Category357019,
  '357036': ContentId.Category357036,
  '358121': ContentId.Category358121,
  '358959': ContentId.Category358959,
  '366262': ContentId.Category366262,
  '366288': ContentId.Category366288,
  '366529': ContentId.Category366529,
  '366888': ContentId.Category366888,
  '375100': ContentId.Category375100,
  '379731': ContentId.Category379731,
  '379991': ContentId.Category379991,
  '380480': ContentId.Category380480,
  '381561': ContentId.Category381561,
  '150002820': ContentId.Category150002820,
  '1014': ContentId.Category1014,
  '1022': ContentId.Category1022,
  '1023': ContentId.Category1023,
  '1026': ContentId.Category1026,
  '1027': ContentId.Category1027,
  '1059': ContentId.Category1059,
  '1205': ContentId.Category1205,
  '14858': ContentId.Category14858,
  '259810': ContentId.Category259810,
  '259815': ContentId.Category259815,
  '259819': ContentId.Category259819,
  '259820': ContentId.Category259820,
  '259822': ContentId.Category259822,
  '259823': ContentId.Category259823,
  '259824': ContentId.Category259824,
  '259827': ContentId.Category259827,
  '259828': ContentId.Category259828,
  '259829': ContentId.Category259829,
  '259833': ContentId.Category259833,
  '259921': ContentId.Category259921,
  '259922': ContentId.Category259922,
  '260261': ContentId.Category260261,
  '260263': ContentId.Category260263,
  '260264': ContentId.Category260264,
  '260265': ContentId.Category260265,
  '260266': ContentId.Category260266,
  '260267': ContentId.Category260267,
  '260268': ContentId.Category260268,
  '260270': ContentId.Category260270,
  '260271': ContentId.Category260271,
  '260275': ContentId.Category260275,
  '260347': ContentId.Category260347,
  '260357': ContentId.Category260357,
  '260385': ContentId.Category260385,
  '260389': ContentId.Category260389,
  '260392': ContentId.Category260392,
  '260421': ContentId.Category260421,
  '260478': ContentId.Category260478,
  '260483': ContentId.Category260483,
  '260492': ContentId.Category260492,
  '260530': ContentId.Category260530,
  '260539': ContentId.Category260539,
  '260542': ContentId.Category260542,
  '260601': ContentId.Category260601,
  '260624': ContentId.Category260624,
  '260628': ContentId.Category260628,
  '260637': ContentId.Category260637,
  '260644': ContentId.Category260644,
  '261289': ContentId.Category261289,
  '261291': ContentId.Category261291,
  '308335': ContentId.Category308335,
  '308336': ContentId.Category308336,
  '308341': ContentId.Category308341,
  '308342': ContentId.Category308342,
  '308344': ContentId.Category308344,
  '308345': ContentId.Category308345,
  '308350': ContentId.Category308350,
  '308351': ContentId.Category308351,
  '308352': ContentId.Category308352,
  '308353': ContentId.Category308353,
  '308355': ContentId.Category308355,
  '308357': ContentId.Category308357,
  '308358': ContentId.Category308358,
  '308363': ContentId.Category308363,
  '308364': ContentId.Category308364,
  '308365': ContentId.Category308365,
  '308385': ContentId.Category308385,
  '321834': ContentId.Category321834,
  '1024': ContentId.Category1024,
};

const STUBHUB_NEW_CATEGORIES: Record<string, ContentId> = {
  // Sports - league-specific categories
  '1006': ContentId.Category1006, // Cricket
  '1012': ContentId.Category1012, // Tennis
  '4080': ContentId.Category4080, // Horse Racing
  '4871': ContentId.Category4871, // NHL
  '5062': ContentId.Category5062, // MLS
  '5084': ContentId.Category5084, // NFL
  '5133': ContentId.Category5133, // Volleyball
  '5213': ContentId.Category5213, // WWE
  '6453': ContentId.Category6453, // NBA
  '6456': ContentId.Category6456, // MLB
  '14163': ContentId.Category14163, // Rugby
  '26796': ContentId.Category26796, // Formula 1
  '260411': ContentId.Category260411, // Funk
  '260557': ContentId.Category260557, // Heavy Metal
  '260597': ContentId.Category260597, // Experimental
  '260598': ContentId.Category260598, // Pop
};

/**
 * StubHub-aligned parent categories map.
 * Extends PARENT_CATEGORY_TO_CID with league-specific categories to match StubHub's navigation menu.
 * Feature flag: StubHubSubGenresInPOS
 */
const {
  '6401': _americanFootball,
  '6404': _basketball,
  '6452': _baseball,
  ...baseCategories
} = PARENT_CATEGORY_TO_CID;

export const STUBHUB_PARENT_CATEGORY_TO_CID: Record<string, ContentId> = {
  ...baseCategories,
  ...STUBHUB_NEW_CATEGORIES,
};

/**
 * Grouped configuration for STUBHUB_PARENT_CATEGORY_TO_CID.
 * Groups sub-genres by their top-level category matching StubHub's navigation dropdown.
 * Source: TopGmsSubcategories.cs from Viagogo.Site.Services
 */
export const STUBHUB_PARENT_CATEGORY_GROUPS: {
  groups: Array<{
    labelContentId: ContentId;
    optionKeys: string[];
  }>;
} = {
  groups: [
    {
      labelContentId: ContentId.Sports,
      optionKeys: [
        '6456', // MLB
        '6453', // NBA
        '5084', // NFL
        '4871', // NHL
        '5062', // MLS
        '1012', // Tennis
        '1009', // Golf
        '5099', // Rodeo
        '26796', // Formula 1
        '273026', // Fight
        '14163', // Rugby
        '4080', // Horse Racing
        '1006', // Cricket
        '263024', // College Sports
        '5213', // WWE
        '5133', // Volleyball
        '273089', // All Other Sports
      ],
    },
    {
      labelContentId: ContentId.Concert,
      optionKeys: [
        '1026', // Rap and Hip-Hop Music
        '1059', // Alternative & Indie
        '260598', // Pop
        '259822', // R&B/Soul Music
        '259827', // Rock
        '260637', // Latin
        '260347', // Country
        '1022', // Dance & Electronic Music
        '260557', // Heavy Metal
        '260411', // Funk
        '260628', // Folk
        '259716', // Classical
        '260644', // Religious
        '260389', // Reggae
        '260597', // Experimental
        '260530', // Vocal
      ],
    },
    {
      labelContentId: ContentId.Theatre,
      optionKeys: [
        '1013', // Ballet & Dance
        '358121', // Broadway
        '1015', // Comedy
        '4551', // Cirque du Soleil
        '259716', // Classical Music & Opera
        '2294', // Family
        '356499', // Festivals & Fairs
        '1017', // Musicals
        '358959', // Plays
        '6403', // Conferences & Speaking Tours
      ],
    },
  ],
};

export const MARKET_PLACE_TO_CID: Record<Marketplace, ContentId | string> = {
  [Marketplace.StubHub]: Marketplace.StubHub,
  [Marketplace.SeatGeek]: Marketplace.SeatGeek,
  [Marketplace.Ticketmaster]: Marketplace.Ticketmaster,
  [Marketplace.VividSeats]: Marketplace.VividSeats,
  [Marketplace.TickPick]: Marketplace.TickPick,
  [Marketplace.Offline]: ContentId.DirectOffline,
  [Marketplace.AXS]: Marketplace.AXS,
  [Marketplace.FanXchange]: Marketplace.FanXchange,
  [Marketplace.Gametime]: Marketplace.Gametime,
  [Marketplace.TicketEvolution]: Marketplace.TicketEvolution,
  [Marketplace.TicketNetwork]: Marketplace.TicketNetwork,
  [Marketplace.Automatiq]: Marketplace.Automatiq,
  [Marketplace.Lyte]: Marketplace.Lyte,
  [Marketplace.GoTickets]: Marketplace.GoTickets,
  [Marketplace.B2BSales]: Marketplace.B2BSales,
  [Marketplace.TicketNetworkMercury]: Marketplace.TicketNetworkMercury,
  [Marketplace.Wastage]: Marketplace.Wastage,
  [Marketplace.ReachPro]: Marketplace.ReachPro,
  [Marketplace.Donation]: Marketplace.Donation,
  [Marketplace.Gigsberg]: Marketplace.Gigsberg,
  [Marketplace.Retail]: Marketplace.Retail,
};

export const YES_NO_ENUM_FILTER_TO_CID: Record<YesNoEnum, ContentId> = {
  [YesNoEnum.Yes]: ContentId.Yes,
  [YesNoEnum.No]: ContentId.No,
};

export const EVENT_PRICED_STATUS_TO_CID: Record<
  EventUnpricedStatus,
  ContentId
> = {
  [EventUnpricedStatus.AllUnpriced]: ContentId.All,
  [EventUnpricedStatus.NoneUnpriced]: ContentId.None,
  [EventUnpricedStatus.AnyUnpriced]: ContentId.Any,
};

export const EVENT_LAST_REVIEWED_SINCE_DATE_CID: Record<
  LastReviewedSinceDate,
  ContentId
> = {
  [LastReviewedSinceDate.LastThreeDays]: ContentId.Last3Days,
  [LastReviewedSinceDate.LastSevenDays]: ContentId.LastWeek,
  [LastReviewedSinceDate.LastTwoWeeks]: ContentId.Last2Weeks,
  [LastReviewedSinceDate.LastThirtyDays]: ContentId.Last30Days,
};

export const CONTAINS_EQUALS_ENUM_FILTER_TO_CID: Record<
  TextFilterEnum,
  ContentId
> = {
  [TextFilterEnum.Contains]: ContentId.Contains,
  [TextFilterEnum.Equals]: ContentId.Equals,
  [TextFilterEnum.NotContains]: ContentId.NotContains,
};

export const SALES_DATE_FILTER_TO_CID: Record<SaleDateFilterEnum, ContentId> = {
  [SaleDateFilterEnum.HasSaleDate]: ContentId.SaleDateFilterOccured,
  [SaleDateFilterEnum.NoSaleDate]: ContentId.SaleDateFilterNotOccured,
};

export const PRICE_UPDATED_DATE_FILTER_TO_CID: Record<
  PriceUpdatedFilterEnum,
  ContentId
> = {
  [PriceUpdatedFilterEnum.PriceUpdatedDate]: ContentId.PriceDateFilterChanged,
  [PriceUpdatedFilterEnum.PriceNotUpdatedDate]:
    ContentId.PriceDateFilterUnchanged,
};

/**
 * This is created when we don't need to show the No option in the filter
 */
export const YES_ENUM_FILTER_TO_CID: Record<string, ContentId> = {
  [YesNoEnum.Yes]: ContentId.Yes,
};

/**
 * This is created because the original YES_NO_ENUM_FILTER_TO_CID was used for
 * filter query "isSeatingUnmapped" and the labels was Seating Unmapped.
 * A new business requirement, asks for called it Seating Mapped, so the values
 * must be inverted in order to continue working.
 */
export const YES_NO_INVERTED_ENUM_FILTER_TO_CID: Record<YesNoEnum, ContentId> =
  {
    [YesNoEnum.Yes]: ContentId.No,
    [YesNoEnum.No]: ContentId.Yes,
  };

export const AUTO_PRICING_RESULT_TYPES_OPTIONS_TO_CID: Record<
  AutoPricingResultType,
  ContentId
> = {
  [AutoPricingResultType.None]: ContentId.NA,
  [AutoPricingResultType.PriceSuccess]: ContentId.Success,
  [AutoPricingResultType.PriceBelowFloor]: ContentId.PriceBelowFloor,
  [AutoPricingResultType.PriceAboveCeiling]: ContentId.PriceAboveCeiling,
  [AutoPricingResultType.PriceBelowMaxAllowedDrop]:
    ContentId.PriceBelowMaxAllowedDrop,
  [AutoPricingResultType.InsufficientComparables]:
    ContentId.InsufficientComparables,
  [AutoPricingResultType.CannotCalculateUndercut]:
    ContentId.CannotCalculateUndercut,
  [AutoPricingResultType.EffectiveCeilingBelowFloor]:
    ContentId.EffectiveCeilingBelowFloor,
  [AutoPricingResultType.MissingSeatScore]: ContentId.MissingSeatScore,
  [AutoPricingResultType.MissingUnitCost]: ContentId.MissingUnitCost,
  [AutoPricingResultType.MissingZone]: ContentId.MissingZone,
  [AutoPricingResultType.PriceHitHardFloor]: ContentId.PriceHitHardFloor,
  [AutoPricingResultType.PriceHitRelativeFloor]:
    ContentId.PriceHitRelativeFloor,
  [AutoPricingResultType.PriceHitMaxAllowedDrop]:
    ContentId.PriceHitMaxAllowedDrop,
  [AutoPricingResultType.ConfigRowMissing]: ContentId.MappingError,
  [AutoPricingResultType.SectionUnmapped]: ContentId.SectionUnmapped,
  [AutoPricingResultType.AllPriceUpdatesPaused]: ContentId.PriceUpdatesPaused,
  [AutoPricingResultType.PriceDecreasesPaused]: ContentId.PriceDecreasesPaused,
};

export const AUTO_PRICING_RESULT_TYPES_OPTIONS_TO_COLOR: Record<
  AutoPricingResultType,
  string
> = {
  [AutoPricingResultType.None]: vars.color.textDisabled,
  [AutoPricingResultType.PriceSuccess]: vars.color.borderSuccess,
  [AutoPricingResultType.PriceBelowFloor]: vars.color.borderWarning,
  [AutoPricingResultType.PriceAboveCeiling]: vars.color.borderWarning,
  [AutoPricingResultType.PriceBelowMaxAllowedDrop]: vars.color.borderWarning,
  [AutoPricingResultType.InsufficientComparables]: vars.color.borderWarning,
  [AutoPricingResultType.CannotCalculateUndercut]: vars.color.borderError,
  [AutoPricingResultType.EffectiveCeilingBelowFloor]: vars.color.borderError,
  [AutoPricingResultType.MissingSeatScore]: vars.color.borderError,
  [AutoPricingResultType.MissingUnitCost]: vars.color.borderError,
  [AutoPricingResultType.MissingZone]: vars.color.borderError,
  [AutoPricingResultType.PriceHitHardFloor]: vars.color.borderWarning,
  [AutoPricingResultType.PriceHitRelativeFloor]: vars.color.borderWarning,
  [AutoPricingResultType.PriceHitMaxAllowedDrop]: vars.color.borderWarning,
  [AutoPricingResultType.ConfigRowMissing]: vars.color.borderError,
  [AutoPricingResultType.SectionUnmapped]: vars.color.borderError,
  [AutoPricingResultType.AllPriceUpdatesPaused]: vars.color.borderError,
  [AutoPricingResultType.PriceDecreasesPaused]: vars.color.borderError,
};

export const DELIVERY_OPTIONS_TO_CID: Record<DeliveryType, ContentId | string> =
  {
    [DeliveryType.InApp]: ContentId.InApp,
    [DeliveryType.PDF]: DeliveryType.PDF, // PDF has no translation
    [DeliveryType.Paper]: ContentId.Paper,
    [DeliveryType.MemberCard]: ContentId.MemberCard,
    [DeliveryType.Wallet]: ContentId.Wallet,
    [DeliveryType.Custom]: ContentId.Custom,
  };

export const TICKET_TYPE_TO_CID: Record<TicketType, ContentId> = {
  [TicketType.Barcode]: ContentId.Barcode,
  [TicketType.ETicket]: ContentId.ETicket,
  [TicketType.QRCode]: ContentId.QRCode,
  [TicketType.Transfer]: ContentId.Transfer,
  [TicketType.ETicketUrl]: ContentId.Wallet,
  [TicketType.SMPWallet]: ContentId.SMPWallet,
  [TicketType.Paper]: ContentId.Paper,
  [TicketType.Season]: ContentId.Season,
  [TicketType.Custom]: ContentId.Custom,
};

export const PENDING_PROOF_STATE_TO_CID: Record<PendingProofState, ContentId> =
  {
    [PendingProofState.PendingProof]: ContentId.ProofOfPurchasedRequired,
    [PendingProofState.PendingReview]: ContentId.PendingReview,
    [PendingProofState.Approved]: ContentId.Approved,
  };

export const PURCHASE_COST_TYPE_TO_CID: Record<
  PurchaseOrderCostType,
  ContentId
> = {
  [PurchaseOrderCostType.Tax]: ContentId.TaxPaid,
  [PurchaseOrderCostType.Shipping]: ContentId.Shipping,
  [PurchaseOrderCostType.CreditCardFee]: ContentId.CreditCardFee,
  [PurchaseOrderCostType.BulkDiscount]: ContentId.BulkDiscount,
  [PurchaseOrderCostType.Cancelled]: ContentId.Cancelled,
  [PurchaseOrderCostType.Other]: ContentId.Other,
};

export const SPLIT_TYPE_TO_CID: Record<SplitType, ContentId | string> = {
  [SplitType.Any]: ContentId.Any,
  [SplitType.None]: ContentId.None,
  [SplitType.AvoidOne]: ContentId.AvoidOne,
  [SplitType.AvoidOneAndThree]: ContentId.AvoidOneAndThree,
  [SplitType.Pairs]: ContentId.Pairs,
};

export const TAG_VALUE_TYPE_TO_CID: Record<string, ContentId> = {
  [TagsValueType.String]: ContentId.Text,
  [TagsValueType.Decimal]: ContentId.DecimalNumber,
  [TagsValueType.Int]: ContentId.WholeNumber,
  [TagsValueType.Boolean]: ContentId.TrueFalse,
  [TagsValueType.Url]: ContentId.Hyperlink,
  [TagsValueType.Marketplace]: ContentId.Marketplace,
  [TagsValueType.Date]: ContentId.Date,
  [TagsValueType.POSUser]: ContentId.Users,
  [TagsValueType.Vendor]: ContentId.Vendors,
  [TagsValueType.UserGroup]: ContentId.Teams,
};

export const TAG_OPERATION_TO_CID: Record<string, ContentId | string> = {
  Contains: ContentId.Contains,
  Equals: ContentId.Equals,
  NotEquals: ContentId.NotEquals,
  NotContains: ContentId.NotContains,
  NoTags: 'No Tags',
};

export const PAYMENT_METHOD_TYPE_TO_CID: Record<
  PurchasePaymentMethodType,
  ContentId | string
> = {
  [PurchasePaymentMethodType.PayPal]: PurchasePaymentMethodType.PayPal, // this is a brand
  [PurchasePaymentMethodType.Check]: ContentId.Check,
  [PurchasePaymentMethodType.ECheck]: ContentId.ECheck,
  [PurchasePaymentMethodType.MoneyOrder]: ContentId.MoneyOrder,
  [PurchasePaymentMethodType.Card]: ContentId.CreditCard,
  [PurchasePaymentMethodType.Cash]: ContentId.Cash,
  [PurchasePaymentMethodType.Credit]: ContentId.Credit,
  [PurchasePaymentMethodType.COD]: ContentId.COD,
  [PurchasePaymentMethodType.BankTransfer]: ContentId.BankTransfer,
  [PurchasePaymentMethodType.DebitCard]: ContentId.DebitCard,
  [PurchasePaymentMethodType.CreditMemo]: ContentId.CreditBalance,
  [PurchasePaymentMethodType.DebitNote]: ContentId.DebitNote,
  [PurchasePaymentMethodType.Other]: ContentId.Other,
};

export const TICKET_GROUP_EDIT_REASON_TO_CID: Record<
  TicketGroupEditReason,
  ContentId
> = {
  [TicketGroupEditReason.AddTickets]: ContentId.AddTickets,
  [TicketGroupEditReason.AmendTickets]: ContentId.AmendTickets,
  [TicketGroupEditReason.CancelTickets]: ContentId.CancelTickets,
  [TicketGroupEditReason.ExchangeTickets]: ContentId.ExchangeTickets,
  [TicketGroupEditReason.EditEvent]: ContentId.ChangeEvent,
};

export const LISTING_STATUS_TO_CID: Record<ListingStatus, ContentId> = {
  [ListingStatus.Delisted]: ContentId.Delisted,
  [ListingStatus.DelistingPending]: ContentId.DelistingPending,
  [ListingStatus.DelistingFailed]: ContentId.ListedDelistFailed,
  [ListingStatus.Listed]: ContentId.Listed,
  [ListingStatus.ListingPending]: ContentId.ListingPending,
  [ListingStatus.ListingFailed]: ContentId.ListingFailed,
  [ListingStatus.FullySold]: ContentId.FullySold,
  [ListingStatus.Disabled]: ContentId.BroadcastDisabled,
};

export const FULFILLMENT_STATE_TO_CID: Record<
  PointOfSaleFulfillmentState,
  ContentId
> = {
  [PointOfSaleFulfillmentState.Ineligible]: ContentId.Ineligible,
  [PointOfSaleFulfillmentState.Pending]: ContentId.Pending,
  [PointOfSaleFulfillmentState.Processing]: ContentId.Processing,
  [PointOfSaleFulfillmentState.PendingPickup]: ContentId.PendingPickup,
  [PointOfSaleFulfillmentState.InTransit]: ContentId.InTransit,
  [PointOfSaleFulfillmentState.Fulfilled]: ContentId.Fulfilled,
  [PointOfSaleFulfillmentState.Resetted]: ContentId.PendingRefulfillment,
  [PointOfSaleFulfillmentState.Failed]: ContentId.Failed,
};

export const LISTING_STATUS_WITH_ACTION_TO_CID: Record<
  ListingStatus,
  ContentId
> = {
  [ListingStatus.Delisted]: ContentId.DelistedClickToList,
  [ListingStatus.DelistingPending]: ContentId.DelistingClickToCancel,
  [ListingStatus.DelistingFailed]: ContentId.DelistingFailedClickToTryAgain,
  [ListingStatus.Listed]: ContentId.ListedClickToDelist,
  [ListingStatus.ListingPending]: ContentId.ListingClickToCancel,
  [ListingStatus.ListingFailed]: ContentId.ListingFailedClickToTryAgain,
  [ListingStatus.FullySold]: ContentId.ListingFullSoldNoActionAvailable,
  [ListingStatus.Disabled]: ContentId.BroadcastDisabled,
};

export const LISTING_TABLE_FLATTENED_COLUMN_ID_TO_CONTENT_ID: Record<
  ListingTableFlattenedColumnId,
  ContentId
> = {
  [ListingTableFlattenedColumnId.Event]: ContentId.Event,
  [ListingTableFlattenedColumnId.Venue]: ContentId.Venue,
  [ListingTableFlattenedColumnId.Location]: ContentId.Location,
  [ListingTableFlattenedColumnId.EventDate]: ContentId.EventDate,
};

export const LISTING_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  ListingTableColumnId,
  ContentId | string
> = {
  [ListingTableColumnId.Checkbox]: ContentId.Checkbox,
  [ListingTableColumnId.TicketClassColor]: ContentId.Zone,
  [ListingTableColumnId.Seating]: ContentId.Seating,
  [ListingTableColumnId.DeliveryType]: ContentId.Delivery,
  [ListingTableColumnId.ShownQuantity]: ContentId.Shown,
  [ListingTableColumnId.UnsoldQuantity]: ContentId.Unsold,
  [ListingTableColumnId.AvailableQuantity]: ContentId.Available,
  [ListingTableColumnId.TicketCount]: ContentId.Total,
  [ListingTableColumnId.InHandDate]: 'IH',
  [ListingTableColumnId.UnitCost]: ContentId.UnitCost,
  [ListingTableColumnId.ListPrice]: ContentId.Proceeds,
  [ListingTableColumnId.AllInPrice]: ContentId.Price,
  [ListingTableColumnId.Actions]: ContentId.Actions,
  [ListingTableColumnId.ListingId]: ContentId.ListingId,
  [ListingTableColumnId.AutoPricing]: ContentId.PriceToMarket,
  [ListingTableColumnId.ProceedsFloor]: ContentId.ProceedsFloor,
  [ListingTableColumnId.ProceedsCeiling]: ContentId.ProceedsCeiling,
  [ListingTableColumnId.WebsiteFloor]: ContentId.WebsiteFloor,
  [ListingTableColumnId.WebsiteCeiling]: ContentId.WebsiteCeiling,
  [ListingTableColumnId.UndercutMode]: ContentId.UndercutMode,
  [ListingTableColumnId.UndercutAbsoluteAmount]:
    ContentId.UndercutAbsoluteAmount,
  [ListingTableColumnId.UndercutRelativeAmount]:
    ContentId.UndercutRelativeAmount,
  [ListingTableColumnId.UndercutNewPrice]: ContentId.MarketPrice,
  [ListingTableColumnId.CompListingMode]: ContentId.CompListingMode,
  [ListingTableColumnId.CompListingFloor]: ContentId.CompListingFloor,
  [ListingTableColumnId.CompListingCeiling]: ContentId.CompListingCeiling,
  [ListingTableColumnId.CompListingMinimumQuantity]:
    ContentId.CompListingMinQuantity,
  [ListingTableColumnId.CompListingExcludeFanInventory]:
    ContentId.ExcludeFanInventory,
  [ListingTableColumnId.OutlierMode]: ContentId.OutlierMode,
  [ListingTableColumnId.OutlierLimit]: ContentId.OutlierLimit,
  [ListingTableColumnId.OutlierFiltering]: ContentId.OutlierFiltering,
  [ListingTableColumnId.OutlierSpacing]: ContentId.OutlierSpacing,
  [ListingTableColumnId.CircuitBreakerMinCompListingCount]:
    ContentId.CompListingMinCount,
  [ListingTableColumnId.CircuitBreakerVelocity]: ContentId.Velocity,
  [ListingTableColumnId.CircuitBreakerVelocityHours]: ContentId.VelocityHours,
  [ListingTableColumnId.SeatingRow]: ContentId.Row,
  [ListingTableColumnId.SeatingSeats]: ContentId.Seats,
  [ListingTableColumnId.AutoPricingResultType]: ContentId.AutoPricingResult,
  [ListingTableColumnId.LastPriceUpdatedDate]: ContentId.LastPriceUpdatedDate,
  [ListingTableColumnId.WastedCost]: ContentId.WastedCost,
  [ListingTableColumnId.WastedTickets]: ContentId.WastedQty,
  [ListingTableColumnId.PurchaseId]: ContentId.ExternalPurchaseIdAbbreviated,
  [ListingTableColumnId.VendorAccount]: ContentId.VendorAccount,
  [ListingTableColumnId.MarketplaceVisibility]: ContentId.MarketplaceVisibility,
  [ListingTableColumnId.PurchaseCreatedBy]: ContentId.CreatedBy,
  [ListingTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
  [ListingTableColumnId.PurchaseDate]: ContentId.PoDate,
  [ListingTableColumnId.RelativeRankPremium]: ContentId.RelativeRankPremium,
  [ListingTableColumnId.AbsoluteRankPremium]: ContentId.AbsoluteRankPremium,
  [ListingTableColumnId.UnsoldProceeds]: ContentId.UnsoldProceeds,
  [ListingTableColumnId.UnsoldCost]: ContentId.UnsoldCost,
  [ListingTableColumnId.SoldQty]: ContentId.SoldQty,
  [ListingTableColumnId.SoldCost]: ContentId.SoldCost,
  [ListingTableColumnId.TotalCost]: ContentId.TotalCost,
  [ListingTableColumnId.AutoFulfill]: ContentId.AutoFulfill,
  [ListingTableColumnId.SeatTraits]: ContentId.SeatTraits,
  [ListingTableColumnId.SplitType]: ContentId.SplitType,
  [ListingTableColumnId.InternalNotes]: ContentId.PrivateNote,
  [ListingTableColumnId.MarketplaceBroadcastStatus]: ContentId.Broadcast,
  [ListingTableColumnId.ConsigneeSellerAccountId]: ContentId.Account,
  [ListingTableColumnId.PricedBy]: ContentId.PricedBy,
};

export const LISTING_REPORT_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  ListingReportTableColumnId,
  ContentId | string
> = {
  [ListingReportTableColumnId.Performer]: ContentId.Performer,
  [ListingReportTableColumnId.Venue]: ContentId.Venue,
  [ListingReportTableColumnId.Event]: ContentId.EventName,
  [ListingReportTableColumnId.UnsoldQuantity]: ContentId.UnsoldQty,
  [ListingReportTableColumnId.SoldQuantity]: ContentId.SoldQty,
  [ListingReportTableColumnId.TicketCount]: ContentId.TotalQty,
  [ListingReportTableColumnId.UnitCost]: ContentId.TotalUnitCost,
  [ListingReportTableColumnId.ListPrice]: ContentId.TotalProceeds,
  [ListingReportTableColumnId.AllInPrice]: ContentId.Price,
  [ListingReportTableColumnId.EventGenre]: ContentId.Genre,
  [ListingReportTableColumnId.EventCountry]: ContentId.Country,
  [ListingReportTableColumnId.EventCity]: ContentId.City,
  [ListingReportTableColumnId.SeatingSection]: ContentId.Section,
  [ListingReportTableColumnId.SeatingRow]: ContentId.Row,
  [ListingReportTableColumnId.SoldCost]: ContentId.SoldCost,
  [ListingReportTableColumnId.SoldProceeds]: ContentId.SoldProceeds,
  [ListingReportTableColumnId.UnsoldCost]: ContentId.UnsoldCost,
  [ListingReportTableColumnId.EventId]: ContentId.EventId,
  [ListingReportTableColumnId.Category]: ContentId.Category,
  [ListingReportTableColumnId.EventDate]: ContentId.EventDate,
  [ListingReportTableColumnId.EventStateProvince]: ContentId.StateProvince,
  [ListingReportTableColumnId.SaleId]: ContentId.SaleId,
  [ListingReportTableColumnId.HoldId]: ContentId.HoldId,
  [ListingReportTableColumnId.SeatingSeats]: ContentId.Seats,
  [ListingReportTableColumnId.DeliveryType]: ContentId.Delivery,
  [ListingReportTableColumnId.InHandDate]: 'IH',
  [ListingReportTableColumnId.PurchaseId]: ContentId.PoId,
  [ListingReportTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
  [ListingReportTableColumnId.PurchaseDate]: ContentId.PoDate,
  [ListingReportTableColumnId.Vendor]: ContentId.Vendor,
  [ListingReportTableColumnId.SalePaymentState]: ContentId.PayState,
  [ListingReportTableColumnId.Charges]: ContentId.Charges,
  [ListingReportTableColumnId.Credits]: ContentId.Credits,
  [ListingReportTableColumnId.Fulfiller]: ContentId.FulfilledBy,
  [ListingReportTableColumnId.ListingId]: ContentId.ListingId,
  [ListingReportTableColumnId.PaymentMethodType]: ContentId.PaymentMethod,
  [ListingReportTableColumnId.PurchasePaymentStatus]: ContentId.POPaymentState,
  [ListingReportTableColumnId.Zone]: ContentId.Zone,
  [ListingReportTableColumnId.PricedBy]: ContentId.PricedBy,
  [ListingReportTableColumnId.InternalNotes]: ContentId.Notes,
  [ListingReportTableColumnId.InternalNotesPurchase]: ContentId.Notes,
  [ListingReportTableColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [ListingReportTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [ListingReportTableColumnId.CancellationDatePurchase]:
    ContentId.CancellationDate,
  [ListingReportTableColumnId.PandL]: ContentId.PandL,
  [ListingReportTableColumnId.Margin]: ContentId.Margin,
  [ListingReportTableColumnId.PurchaseCreatedBy]: ContentId.POCreatedBy,
};

export const LISTING_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  ListingReportTableGroupingColumnId,
  ContentId
> = {
  [ListingReportTableGroupingColumnId.PerformerName]: ContentId.Performer,
  [ListingReportTableGroupingColumnId.VenueName]: ContentId.Venue,
  [ListingReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [ListingReportTableGroupingColumnId.TopLevelCategoryName]: ContentId.Genre,
  [ListingReportTableGroupingColumnId.ParentCategoryName]: ContentId.SubGenre,
  [ListingReportTableGroupingColumnId.CountryName]: ContentId.Country,
  [ListingReportTableGroupingColumnId.CityName]: ContentId.City,
  [ListingReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [ListingReportTableGroupingColumnId.LocalEventDateTime]: ContentId.EventDate,
  [ListingReportTableGroupingColumnId.StateProvince]: ContentId.StateProvince,
  [ListingReportTableGroupingColumnId.InternalNotes]: ContentId.PrivateNote,
  [ListingReportTableGroupingColumnId.ListingId]: ContentId.ListingId,
  [ListingReportTableGroupingColumnId.IsSeatSaver]: ContentId.Placeholder,
  [ListingReportTableGroupingColumnId.IsNoFulfill]: ContentId.AutoFulfill,
  [ListingReportTableGroupingColumnId.PricerSellerUserId]: ContentId.PricedBy,
  [ListingReportTableGroupingColumnId.Section]: ContentId.Section,
  [ListingReportTableGroupingColumnId.SeatingRow]: ContentId.Row,
  [ListingReportTableGroupingColumnId.SeatFrom]: ContentId.SeatFrom,
  [ListingReportTableGroupingColumnId.SeatTo]: ContentId.SeatTo,
  [ListingReportTableGroupingColumnId.PurchaseOrderId]: ContentId.PoId,
  [ListingReportTableGroupingColumnId.PurchaseOrderDate]: ContentId.PoDate,
  [ListingReportTableGroupingColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [ListingReportTableGroupingColumnId.PurchaseOrderVendorName]:
    ContentId.Vendor,
  [ListingReportTableGroupingColumnId.PurchasePaymentStatusName]:
    ContentId.POPaymentState,
  [ListingReportTableGroupingColumnId.PurchaseInternalNotes]: ContentId.PONotes,
  [ListingReportTableGroupingColumnId.PurchasePaymentMethodTypeName]:
    ContentId.POPaymentMethod,
  [ListingReportTableGroupingColumnId.PaymentMethodFullInfo]:
    ContentId.PaymentMethods,
  [ListingReportTableGroupingColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [ListingReportTableGroupingColumnId.VendorAccountEmail]:
    ContentId.VendorAccount,
  [ListingReportTableGroupingColumnId.DeliveryTypeName]: ContentId.DeliveryType,
  [ListingReportTableGroupingColumnId.PurchaseOrderInsertBy]:
    ContentId.POCreatedBy,
  [ListingReportTableGroupingColumnId.PurchaseOrderCancellationDate]:
    ContentId.CancellationDate,
  [ListingReportTableGroupingColumnId.EventStateName]: ContentId.EventState,
  [ListingReportTableGroupingColumnId.InHandDate]: ContentId.InHandDate,
  [ListingReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [ListingReportTableGroupingColumnId.HoldId]: ContentId.HoldId,
  [ListingReportTableGroupingColumnId.MarketplacePaymentStateName]:
    ContentId.PayState,
  [ListingReportTableGroupingColumnId.FulfillerSellerUserId]:
    ContentId.FulfilledBy,
};

export const LISTING_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  ListingReportTableValueColumnId,
  ContentId
> = {
  [ListingReportTableValueColumnId.UnsoldQuantity]: ContentId.UnsoldQty,
  [ListingReportTableValueColumnId.SoldQuantity]: ContentId.SoldQuantity,
  [ListingReportTableValueColumnId.TotalQuantity]: ContentId.TotalQuantity,
  [ListingReportTableValueColumnId.UnitAllInPrice]: ContentId.WebsitePrice,
  [ListingReportTableValueColumnId.UnitNetProceeds]: ContentId.Proceeds,
  [ListingReportTableValueColumnId.SoldCost]: ContentId.SoldCost,
  [ListingReportTableValueColumnId.UnsoldCost]: ContentId.UnsoldCost,
  [ListingReportTableValueColumnId.WastedCost]: ContentId.WastedCost,
  [ListingReportTableValueColumnId.WastedQuantity]: ContentId.WastedQty,
  [ListingReportTableValueColumnId.UnitCost]: ContentId.UnitCost,
  [ListingReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [ListingReportTableValueColumnId.TotalListPrice]: ContentId.TotalProceeds,
  [ListingReportTableValueColumnId.TotalAllInPrice]:
    ContentId.TotalWebsitePrice,
  [ListingReportTableValueColumnId.SoldProceeds]: ContentId.SoldProceeds,
  [ListingReportTableValueColumnId.Charges]: ContentId.Charges,
  [ListingReportTableValueColumnId.Credits]: ContentId.Credits,
  [ListingReportTableValueColumnId.PandL]: ContentId.PandL,
  [ListingReportTableValueColumnId.Margin]: ContentId.Margin,
};

export const SALES_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  SalesReportTableGroupingColumnId,
  ContentId
> = {
  [SalesReportTableGroupingColumnId.PerformerName]: ContentId.Performer,
  [SalesReportTableGroupingColumnId.VenueName]: ContentId.Venue,
  [SalesReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [SalesReportTableGroupingColumnId.TopLevelCategoryName]: ContentId.Genre,
  [SalesReportTableGroupingColumnId.ParentCategoryName]: ContentId.SubGenre,
  [SalesReportTableGroupingColumnId.CountryName]: ContentId.Country,
  [SalesReportTableGroupingColumnId.CityName]: ContentId.City,
  [SalesReportTableGroupingColumnId.Section]: ContentId.Section,
  [SalesReportTableGroupingColumnId.SeatingRow]: ContentId.Row,
  [SalesReportTableGroupingColumnId.SeatFrom]: ContentId.SeatFrom,
  [SalesReportTableGroupingColumnId.SeatTo]: ContentId.SeatTo,
  [SalesReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [SalesReportTableGroupingColumnId.LocalEventDateTime]: ContentId.EventDate,
  [SalesReportTableGroupingColumnId.StateProvince]: ContentId.StateProvince,
  [SalesReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [SalesReportTableGroupingColumnId.InternalNotes]: ContentId.PrivateNote,
  [SalesReportTableGroupingColumnId.SaleDate]: ContentId.SaleDate,
  [SalesReportTableGroupingColumnId.SaleStatusName]: ContentId.SaleStatus,
  [SalesReportTableGroupingColumnId.PaymentReferenceId]: ContentId.PayRef,
  [SalesReportTableGroupingColumnId.TicketTypeName]: ContentId.Ticket,
  [SalesReportTableGroupingColumnId.InHandDate]: ContentId.InHandDate,
  [SalesReportTableGroupingColumnId.LastPaymentDate]: ContentId.PaymentDate,
  [SalesReportTableGroupingColumnId.CancellationDate]:
    ContentId.CancellationDate,
  [SalesReportTableGroupingColumnId.FulfillerSellerUserId]:
    ContentId.FulfilledBy,
  [SalesReportTableGroupingColumnId.FulfillmentDate]: ContentId.FulfillmentDate,
  [SalesReportTableGroupingColumnId.MarketplacePaymentStateName]:
    ContentId.PayState,
  [SalesReportTableGroupingColumnId.MarketplaceName]: ContentId.Marketplace,
  [SalesReportTableGroupingColumnId.MarketplaceSaleId]:
    ContentId.ExternalSaleId,
  [SalesReportTableGroupingColumnId.IsSeatSaver]: ContentId.Placeholder,
  [SalesReportTableGroupingColumnId.IsNoFulfill]: ContentId.AutoFulfill,
  [SalesReportTableGroupingColumnId.SaleMonth]: ContentId.SaleMonth,
  [SalesReportTableGroupingColumnId.SaleWeek]: ContentId.SaleWeek,
  [SalesReportTableGroupingColumnId.SaleDay]: ContentId.SaleDay,
  [SalesReportTableGroupingColumnId.PurchaseOrderId]: ContentId.PoId,
  [SalesReportTableGroupingColumnId.PurchaseOrderDate]: ContentId.PoDate,
  [SalesReportTableGroupingColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [SalesReportTableGroupingColumnId.PurchaseOrderVendorName]: ContentId.Vendor,
  [SalesReportTableGroupingColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [SalesReportTableGroupingColumnId.VendorAccountEmail]:
    ContentId.VendorAccount,
  [SalesReportTableGroupingColumnId.PurchaseOrderInsertBy]:
    ContentId.POCreatedBy,
  [SalesReportTableGroupingColumnId.EventStateName]: ContentId.EventState,
  [SalesReportTableGroupingColumnId.PricerSellerUserId]: ContentId.PricedBy,
  [SalesReportTableGroupingColumnId.PaymentReceived]: ContentId.PaymentReceived,
  [SalesReportTableGroupingColumnId.CurrencyCode]: ContentId.Currency,
  [SalesReportTableGroupingColumnId.SaleCancellationReason]:
    ContentId.CancellationReason,
  [SalesReportTableGroupingColumnId.ListingNoteTexts]: ContentId.SeatTraits,
  [SalesReportTableGroupingColumnId.ListingId]: ContentId.ListingId,
};

export const SALES_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Partial<
  Record<SalesReportTableValueColumnId, ContentId>
> = {
  [SalesReportTableValueColumnId.QuantitySold]: ContentId.SoldQty,
  [SalesReportTableValueColumnId.QuantityWasted]: ContentId.WastedQty,
  [SalesReportTableValueColumnId.TotalNetProceeds]: ContentId.TotalNetProceeds,
  [SalesReportTableValueColumnId.TotalPaymentAmount]: ContentId.PaymentAmount,
  [SalesReportTableValueColumnId.Charges]: ContentId.Charges,
  [SalesReportTableValueColumnId.Credits]: ContentId.Credits,
  [SalesReportTableValueColumnId.OutstandingBalance]:
    ContentId.OutstandingBalance,
  [SalesReportTableValueColumnId.PandL]: ContentId.PandL,
  [SalesReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [SalesReportTableValueColumnId.Margin]: ContentId.Margin,
};

export const COMMISSION_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  CommissionReportTableGroupingColumnId,
  ContentId
> = {
  [CommissionReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [CommissionReportTableGroupingColumnId.MarketplaceName]:
    ContentId.Marketplace,
  [CommissionReportTableGroupingColumnId.MarketplaceSaleId]:
    ContentId.ExternalSaleId,
  [CommissionReportTableGroupingColumnId.Commissioner]: ContentId.Commissioner,
  [CommissionReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [CommissionReportTableGroupingColumnId.EventDateLocal]: ContentId.EventDate,
  [CommissionReportTableGroupingColumnId.VenueName]: ContentId.VenueName,
  [CommissionReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [CommissionReportTableGroupingColumnId.EventStateName]: ContentId.EventState,
  [CommissionReportTableGroupingColumnId.SaleStatusName]: ContentId.SaleStatus,
  [CommissionReportTableGroupingColumnId.Section]: ContentId.Section,
  [CommissionReportTableGroupingColumnId.SeatingRow]: ContentId.Row,
  [CommissionReportTableGroupingColumnId.SeatFrom]: ContentId.SeatFrom,
  [CommissionReportTableGroupingColumnId.SeatTo]: ContentId.SeatTo,
  [CommissionReportTableGroupingColumnId.FulfillmentDate]:
    ContentId.FulfillmentDate,
  [CommissionReportTableGroupingColumnId.LastPaymentDate]:
    ContentId.PaymentDate,
  [CommissionReportTableGroupingColumnId.NetCommissionRate]:
    ContentId.NetCommissionRate,
  [CommissionReportTableGroupingColumnId.NetCommissionRateOverride]:
    ContentId.NetCommissionRateOverride,
  [CommissionReportTableGroupingColumnId.SaleBasisShare]:
    ContentId.SaleBasisShare,
  [CommissionReportTableGroupingColumnId.IsCommissionEligible]:
    ContentId.CommissionEligible,
  [CommissionReportTableGroupingColumnId.CommissionEligibilityDate]:
    ContentId.CommissionEligibilityDate,
};

export const COMMISSION_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  CommissionReportTableValueColumnId,
  ContentId
> = {
  [CommissionReportTableValueColumnId.TotalNetProceeds]:
    ContentId.TotalNetProceeds,
  [CommissionReportTableValueColumnId.Credits]: ContentId.Credits,
  [CommissionReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [CommissionReportTableValueColumnId.Charges]: ContentId.Charges,
  [CommissionReportTableValueColumnId.CommissionerCostsAndCharges]:
    ContentId.CommissionerCostsAndCharges,
  [CommissionReportTableValueColumnId.CommissionerProceedsAndCredits]:
    ContentId.CommissionerProceedsAndCredits,
  [CommissionReportTableValueColumnId.CommissionerProfitAndLoss]:
    ContentId.CommissionerProfitAndLoss,
  [CommissionReportTableValueColumnId.OriginalProceeds]:
    ContentId.OriginalProceeds,
};

export const SOLD_TICKET_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  SoldTicketReportTableGroupingColumnId,
  ContentId
> = {
  [SoldTicketReportTableGroupingColumnId.EventDateLocal]: ContentId.EventDate,
  [SoldTicketReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [SoldTicketReportTableGroupingColumnId.VenueName]: ContentId.Venue,
  [SoldTicketReportTableGroupingColumnId.CityName]: ContentId.City,
  [SoldTicketReportTableGroupingColumnId.StateProvince]:
    ContentId.StateProvince,
  [SoldTicketReportTableGroupingColumnId.CountryName]: ContentId.Country,
  [SoldTicketReportTableGroupingColumnId.PerformerName]: ContentId.Performer,
  [SoldTicketReportTableGroupingColumnId.TopLevelCategoryName]: ContentId.Genre,
  [SoldTicketReportTableGroupingColumnId.ParentCategoryName]:
    ContentId.SubGenre,
  [SoldTicketReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [SoldTicketReportTableGroupingColumnId.Section]: ContentId.Section,
  [SoldTicketReportTableGroupingColumnId.SeatingRow]: ContentId.Row,
  [SoldTicketReportTableGroupingColumnId.Seat]: ContentId.Seat,
  [SoldTicketReportTableGroupingColumnId.ListingId]: ContentId.ListingId,
  [SoldTicketReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [SoldTicketReportTableGroupingColumnId.SaleDate]: ContentId.SaleDate,
  [SoldTicketReportTableGroupingColumnId.SaleDay]: ContentId.SaleDay,
  [SoldTicketReportTableGroupingColumnId.SaleWeek]: ContentId.SaleWeek,
  [SoldTicketReportTableGroupingColumnId.SaleMonth]: ContentId.SaleMonth,
  [SoldTicketReportTableGroupingColumnId.SaleStatusName]: ContentId.SaleStatus,
  [SoldTicketReportTableGroupingColumnId.PaymentReferenceId]: ContentId.PayRef,
  [SoldTicketReportTableGroupingColumnId.TicketTypeId]: ContentId.TicketType,
  [SoldTicketReportTableGroupingColumnId.InHandDate]: ContentId.InHandDate,
  [SoldTicketReportTableGroupingColumnId.LastPaymentDate]:
    ContentId.PaymentDate,
  [SoldTicketReportTableGroupingColumnId.SaleCancellationDate]:
    ContentId.SaleCancellationDate,
  [SoldTicketReportTableGroupingColumnId.FulfillerSellerUserId]:
    ContentId.FulfilledBy,
  [SoldTicketReportTableGroupingColumnId.FulfillmentDate]:
    ContentId.FulfillmentDate,
  [SoldTicketReportTableGroupingColumnId.SaleInternalNotes]:
    ContentId.SalePrivateNote,
  [SoldTicketReportTableGroupingColumnId.SaleMarketplacePaymentStateName]:
    ContentId.PayState,
  [SoldTicketReportTableGroupingColumnId.MarketplaceSaleId]:
    ContentId.ExternalSaleId,
  [SoldTicketReportTableGroupingColumnId.MarketplaceName]:
    ContentId.Marketplace,
  [SoldTicketReportTableGroupingColumnId.IsSeatSaver]: ContentId.Placeholder,
  [SoldTicketReportTableGroupingColumnId.IsNoFulfill]: ContentId.AutoFulfill,
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderId]: ContentId.PoId,
  [SoldTicketReportTableGroupingColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [SoldTicketReportTableGroupingColumnId.PurchaseInsertedBy]:
    ContentId.POCreatedBy,
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderDate]: ContentId.PoDate,
  [SoldTicketReportTableGroupingColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderVendorName]:
    ContentId.Vendor,
  [SoldTicketReportTableGroupingColumnId.EncryptedEmailAddress]:
    ContentId.VendorAccount,
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderCancellationDate]:
    ContentId.POCancellationDate,
  [SoldTicketReportTableGroupingColumnId.PurchasePaymentStatusName]:
    ContentId.POPaymentState,
  [SoldTicketReportTableGroupingColumnId.PurchasePaymentMethodTypeName]:
    ContentId.POPaymentMethod,
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderInternalNotes]:
    ContentId.PONotes,
  [SoldTicketReportTableGroupingColumnId.SaleSeatFrom]: ContentId.SaleSeatFrom,
  [SoldTicketReportTableGroupingColumnId.SaleSeatTo]: ContentId.SaleSeatTo,
};

export const SOLD_TICKET_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  SoldTicketReportTableValueColumnId,
  ContentId
> = {
  [SoldTicketReportTableValueColumnId.UnitNetProceeds]: ContentId.SoldProceeds,
  [SoldTicketReportTableValueColumnId.Charges]: ContentId.Charges,
  [SoldTicketReportTableValueColumnId.Credits]: ContentId.Credits,
  [SoldTicketReportTableValueColumnId.OutstandingBalance]:
    ContentId.OutstandingBalance,
  [SoldTicketReportTableValueColumnId.PandL]: ContentId.PandL,
  [SoldTicketReportTableValueColumnId.Margin]: ContentId.Margin,
  [SoldTicketReportTableValueColumnId.UnitCost]: ContentId.UnitCost,
  [SoldTicketReportTableValueColumnId.UnitCostFeesIncluded]:
    ContentId.UnitCostFeesIncluded,
  [SoldTicketReportTableValueColumnId.Quantity]: ContentId.Quantity,
};
export const PURCHASE_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  PurchaseReportTableGroupingColumnId,
  ContentId
> = {
  [PurchaseReportTableGroupingColumnId.PurchaseOrderId]: ContentId.PoId,
  [PurchaseReportTableGroupingColumnId.OrderId]: ContentId.OrderId,
  [PurchaseReportTableGroupingColumnId.InsertBy]: ContentId.POCreatedBy,
  [PurchaseReportTableGroupingColumnId.PurchaseOrderDate]: ContentId.PoDate,
  [PurchaseReportTableGroupingColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [PurchaseReportTableGroupingColumnId.PurchaseOrderVendorName]:
    ContentId.Vendor,
  [PurchaseReportTableGroupingColumnId.EncryptedEmailAddress]:
    ContentId.VendorAccount,
  [PurchaseReportTableGroupingColumnId.PurchaseCancellationDate]:
    ContentId.CancellationDate,
  [PurchaseReportTableGroupingColumnId.PurchasePaymentStatusName]:
    ContentId.POPaymentState,
  [PurchaseReportTableGroupingColumnId.PurchasePaymentMethodTypeName]:
    ContentId.PaymentMethodType,
  [PurchaseReportTableGroupingColumnId.PaymentMethodFullInfo]:
    ContentId.PaymentMethods,
  [PurchaseReportTableGroupingColumnId.InternalNotes]: ContentId.Notes,
};

export const PURCHASE_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  PurchaseReportTableValueColumnId,
  ContentId
> = {
  [PurchaseReportTableValueColumnId.UnitCost]: ContentId.UnitCost,
  [PurchaseReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [PurchaseReportTableValueColumnId.OutstandingBalance]:
    ContentId.OutstandingBalance,
  [PurchaseReportTableValueColumnId.TotalPaymentAmount]:
    ContentId.PaymentAmount,
};

export const SALE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  SaleLineItemReportTableGroupingColumnId,
  ContentId
> = {
  [SaleLineItemReportTableGroupingColumnId.EventDateLocal]: ContentId.EventDate,
  [SaleLineItemReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [SaleLineItemReportTableGroupingColumnId.VenueName]: ContentId.Venue,
  [SaleLineItemReportTableGroupingColumnId.CityName]: ContentId.City,
  [SaleLineItemReportTableGroupingColumnId.StateProvince]:
    ContentId.StateProvince,
  [SaleLineItemReportTableGroupingColumnId.CountryName]: ContentId.Country,
  [SaleLineItemReportTableGroupingColumnId.PerformerName]: ContentId.Performer,
  [SaleLineItemReportTableGroupingColumnId.TopLevelCategoryName]:
    ContentId.Genre,
  [SaleLineItemReportTableGroupingColumnId.ParentCategoryName]:
    ContentId.SubGenre,
  [SaleLineItemReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [SaleLineItemReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [SaleLineItemReportTableGroupingColumnId.SaleCostTypeName]: ContentId.Type,
  [SaleLineItemReportTableGroupingColumnId.PaymentReferenceId]:
    ContentId.PayRef,
  [SaleLineItemReportTableGroupingColumnId.ChargeReason]:
    ContentId.ChargeReasons,
  [SaleLineItemReportTableGroupingColumnId.CreditReason]:
    ContentId.CreditReasons,
  [SaleLineItemReportTableGroupingColumnId.CostMonth]: ContentId.CostMonth,
  [SaleLineItemReportTableGroupingColumnId.CostWeek]: ContentId.CostWeek,
  [SaleLineItemReportTableGroupingColumnId.CostDay]: ContentId.CostDay,
  [SaleLineItemReportTableGroupingColumnId.SellerAccountCurrencyCode]:
    ContentId.SellerAccountCurrencyCode,
};

export const SALE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  SaleLineItemReportTableValueColumnId,
  ContentId
> = {
  [SaleLineItemReportTableValueColumnId.Cost]: ContentId.Cost,
  [SaleLineItemReportTableValueColumnId.Credit]: ContentId.Credit,
  [SaleLineItemReportTableValueColumnId.Charge]: ContentId.Charge,
};

export const PURCHASE_LINE_ITEM_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  PurchaseOrderLineItemReportTableGroupingColumnId,
  ContentId
> = {
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderLineItemId]:
    ContentId.PurchaseOrderPaymentLineId,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderId]:
    ContentId.PurchaseId,
  [PurchaseOrderLineItemReportTableGroupingColumnId.CurrencyCode]:
    ContentId.Currency,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderDate]:
    ContentId.PurchaseDate,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderState]:
    ContentId.PurchaseOrderState,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchasePaymentStatusName]:
    ContentId.POPaymentState,
  [PurchaseOrderLineItemReportTableGroupingColumnId.BuyerUserId]:
    ContentId.PurchasedBy,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderVendorName]:
    ContentId.Vendor,
  [PurchaseOrderLineItemReportTableGroupingColumnId.OrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [PurchaseOrderLineItemReportTableGroupingColumnId.VendorAccountEmail]:
    ContentId.VendorAccount,
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseCancellationDate]:
    ContentId.POCancellationDate,
  [PurchaseOrderLineItemReportTableGroupingColumnId.CostMonth]:
    ContentId.CostMonth,
  [PurchaseOrderLineItemReportTableGroupingColumnId.CostWeek]:
    ContentId.CostWeek,
  [PurchaseOrderLineItemReportTableGroupingColumnId.CostDay]: ContentId.CostDay,
};

export const PURCHASE_LINE_ITEM_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  PurchaseOrderLineItemReportTableValueColumnId,
  ContentId
> = {
  [PurchaseOrderLineItemReportTableValueColumnId.Tax]: ContentId.Tax,
  [PurchaseOrderLineItemReportTableValueColumnId.Shipping]: ContentId.Shipping,
  [PurchaseOrderLineItemReportTableValueColumnId.CreditCardFee]:
    ContentId.CreditCardFee,
  [PurchaseOrderLineItemReportTableValueColumnId.BulkDiscount]:
    ContentId.BulkDiscount,
  [PurchaseOrderLineItemReportTableValueColumnId.Cancelled]:
    ContentId.Cancelled,
};

export const COST_OF_GOODS_SOLD_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  CostOfGoodsSoldReportTableGroupingColumnId,
  ContentId
> = {
  [CostOfGoodsSoldReportTableGroupingColumnId.AuditDateTime]:
    ContentId.ChangeDate,
  [CostOfGoodsSoldReportTableGroupingColumnId.PurchaseOrderId]:
    ContentId.PurchaseId,
  [CostOfGoodsSoldReportTableGroupingColumnId.TicketGroupId]:
    ContentId.TicketGroupId,
  [CostOfGoodsSoldReportTableGroupingColumnId.PreviousCurrencyCode]:
    ContentId.PreviousCurrencyCode,
  [CostOfGoodsSoldReportTableGroupingColumnId.PreviousIsActive]:
    ContentId.PreviousIsActive,
  [CostOfGoodsSoldReportTableGroupingColumnId.CurrencyCode]:
    ContentId.CurrencyCode,
  [CostOfGoodsSoldReportTableGroupingColumnId.IsActive]: ContentId.Active,
  [CostOfGoodsSoldReportTableGroupingColumnId.AdjustmentType]:
    ContentId.AdjustmentType,
  [CostOfGoodsSoldReportTableGroupingColumnId.AuditMonth]:
    ContentId.ChangeDateMonth,
  [CostOfGoodsSoldReportTableGroupingColumnId.AuditWeek]:
    ContentId.ChangeDateWeek,
  [CostOfGoodsSoldReportTableGroupingColumnId.AuditDay]:
    ContentId.ChangeDateDay,
};

export const COST_OF_GOODS_SOLD_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  CostOfGoodsSoldReportTableValueColumnId,
  ContentId
> = {
  [CostOfGoodsSoldReportTableValueColumnId.UnitCostChangeInCurrentCurrency]:
    ContentId.UnitCostChange,
  [CostOfGoodsSoldReportTableValueColumnId.PreviousUnitCost]:
    ContentId.PreviousUnitCost,
  [CostOfGoodsSoldReportTableValueColumnId.UnitCost]: ContentId.UnitCost,
  [CostOfGoodsSoldReportTableValueColumnId.PreviousTotalCost]:
    ContentId.PreviousTotalCost,
  [CostOfGoodsSoldReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [CostOfGoodsSoldReportTableValueColumnId.TotalCostChangeInCurrentCurrency]:
    ContentId.TotalCostChange,
  [CostOfGoodsSoldReportTableValueColumnId.PreviousNumberOfTickets]:
    ContentId.PreviousNumberOfTickets,
  [CostOfGoodsSoldReportTableValueColumnId.NumberOfTickets]:
    ContentId.NumberOfTickets,
  [CostOfGoodsSoldReportTableValueColumnId.NumberOfTicketsChange]:
    ContentId.NumberOfTicketsChange,
};

export const SALE_COST_ADJUSTMENTS_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  SaleCostAdjustmentsReportTableGroupingColumnId,
  ContentId
> = {
  [SaleCostAdjustmentsReportTableGroupingColumnId.AuditDateTime]:
    ContentId.ChangeDate,
  [SaleCostAdjustmentsReportTableGroupingColumnId.SaleId]: ContentId.SaleId,
  [SaleCostAdjustmentsReportTableGroupingColumnId.PreviousCurrencyCode]:
    ContentId.PreviousCurrencyCode,
  [SaleCostAdjustmentsReportTableGroupingColumnId.CurrencyCode]:
    ContentId.CurrencyCode,
  [SaleCostAdjustmentsReportTableGroupingColumnId.AdjustmentType]:
    ContentId.AdjustmentType,
  [SaleCostAdjustmentsReportTableGroupingColumnId.AuditMonth]:
    ContentId.ChangeDateMonth,
  [SaleCostAdjustmentsReportTableGroupingColumnId.AuditWeek]:
    ContentId.ChangeDateWeek,
  [SaleCostAdjustmentsReportTableGroupingColumnId.AuditDay]:
    ContentId.ChangeDateDay,
};

export const SALE_COST_ADJUSTMENTS_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  SaleCostAdjustmentsReportTableValueColumnId,
  ContentId
> = {
  [SaleCostAdjustmentsReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [SaleCostAdjustmentsReportTableValueColumnId.PreviousTotalCost]:
    ContentId.PreviousTotalCost,
  [SaleCostAdjustmentsReportTableValueColumnId.TotalCostChangeInCurrentCurrency]:
    ContentId.TotalCostChange,
  [SaleCostAdjustmentsReportTableValueColumnId.QuantitySold]:
    ContentId.SoldQuantity,
  [SaleCostAdjustmentsReportTableValueColumnId.PreviousQuantitySold]:
    ContentId.PreviousSoldQuantity,
  [SaleCostAdjustmentsReportTableValueColumnId.QuantityChange]:
    ContentId.SoldQuantityChange,
};

export const TICKET_GROUP_REPORT_TABLE_GROUPING_COLUMN_ID_TO_CONTENT_ID: Record<
  TicketGroupReportTableGroupingColumnId,
  ContentId
> = {
  [TicketGroupReportTableGroupingColumnId.TicketGroupId]:
    ContentId.TicketGroupId,
  [TicketGroupReportTableGroupingColumnId.PurchaseOrderId]:
    ContentId.PurchaseId,
  [TicketGroupReportTableGroupingColumnId.PurchaseOrderDate]:
    ContentId.PurchaseDate,
  [TicketGroupReportTableGroupingColumnId.DeliveryTypeName]:
    ContentId.DeliveryType,
  [TicketGroupReportTableGroupingColumnId.InHandDate]: ContentId.InHandDate,
  [TicketGroupReportTableGroupingColumnId.Section]: ContentId.Section,
  [TicketGroupReportTableGroupingColumnId.SeatingRow]: ContentId.Row,
  [TicketGroupReportTableGroupingColumnId.SeatFrom]: ContentId.SeatFrom,
  [TicketGroupReportTableGroupingColumnId.SeatTo]: ContentId.SeatTo,
  [TicketGroupReportTableGroupingColumnId.PreDeliveryStateName]:
    ContentId.PreDelivered,
  [TicketGroupReportTableGroupingColumnId.OrderId]: ContentId.OrderId,
  [TicketGroupReportTableGroupingColumnId.InsertBy]: ContentId.POCreatedBy,
  [TicketGroupReportTableGroupingColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [TicketGroupReportTableGroupingColumnId.PurchaseOrderVendorName]:
    ContentId.Vendor,
  [TicketGroupReportTableGroupingColumnId.EncryptedEmailAddress]:
    ContentId.VendorAccount,
  [TicketGroupReportTableGroupingColumnId.PurchaseCancellationDate]:
    ContentId.POCancellationDate,
  [TicketGroupReportTableGroupingColumnId.PurchasePaymentStatusName]:
    ContentId.POPaymentState,
  [TicketGroupReportTableGroupingColumnId.PurchasePaymentMethodTypeName]:
    ContentId.PaymentMethodType,
  [TicketGroupReportTableGroupingColumnId.PaymentMethodFullInfo]:
    ContentId.PaymentMethods,
  [TicketGroupReportTableGroupingColumnId.InternalNotes]: ContentId.PrivateNote,
  [TicketGroupReportTableGroupingColumnId.IsConsignment]: ContentId.Consignment,
  [TicketGroupReportTableGroupingColumnId.ListingNoteTexts]:
    ContentId.SeatTraits,
  [TicketGroupReportTableGroupingColumnId.EventId]: ContentId.EventId,
  [TicketGroupReportTableGroupingColumnId.LocalEventDateTime]:
    ContentId.EventDate,
  [TicketGroupReportTableGroupingColumnId.EventName]: ContentId.EventName,
  [TicketGroupReportTableGroupingColumnId.VenueName]: ContentId.Venue,
  [TicketGroupReportTableGroupingColumnId.CityName]: ContentId.City,
  [TicketGroupReportTableGroupingColumnId.StateProvince]:
    ContentId.StateProvince,
  [TicketGroupReportTableGroupingColumnId.CountryName]: ContentId.Country,
  [TicketGroupReportTableGroupingColumnId.PerformerName]: ContentId.Performer,
  [TicketGroupReportTableGroupingColumnId.TopLevelCategoryName]:
    ContentId.Genre,
  [TicketGroupReportTableGroupingColumnId.ParentCategoryName]:
    ContentId.SubGenre,
  [TicketGroupReportTableGroupingColumnId.EventStateName]: ContentId.EventState,
  [TicketGroupReportTableGroupingColumnId.TicketStatus]: ContentId.TicketStatus,
};

export const TICKET_GROUP_REPORT_TABLE_VALUE_COLUMN_ID_TO_CONTENT_ID: Record<
  TicketGroupReportTableValueColumnId,
  ContentId
> = {
  [TicketGroupReportTableValueColumnId.UnitCost]: ContentId.UnitCost,
  [TicketGroupReportTableValueColumnId.TotalCost]: ContentId.TotalCost,
  [TicketGroupReportTableValueColumnId.NumberOfTickets]:
    ContentId.NumberOfTickets,
  [TicketGroupReportTableValueColumnId.SoldQuantity]: ContentId.SoldQuantity,
  [TicketGroupReportTableValueColumnId.UnsoldQuantity]:
    ContentId.UnsoldQuantity,
  [TicketGroupReportTableValueColumnId.Charges]: ContentId.Charges,
  [TicketGroupReportTableValueColumnId.Credits]: ContentId.Credits,
  [TicketGroupReportTableValueColumnId.SoldCost]: ContentId.SoldCost,
  [TicketGroupReportTableValueColumnId.TotalNetProceeds]:
    ContentId.TotalNetProceeds,
  [TicketGroupReportTableValueColumnId.PandL]: ContentId.PandL,
  [TicketGroupReportTableValueColumnId.Margin]: ContentId.Margin,
};

export const SITE_THEME_OPTION_TO_CID_MAP: Record<SiteThemeOption, ContentId> =
  {
    [SiteThemeOption.System]: ContentId.SyncWithSystemSettings,
    [SiteThemeOption.Light]: ContentId.Light,
    [SiteThemeOption.Dark]: ContentId.Dark,
  };

export const EVENTS_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  EventsTableColumnId,
  ContentId
> = {
  [EventsTableColumnId.Checkbox]: ContentId.Checkbox,
  [EventsTableColumnId.Event]: ContentId.EventName,
  [EventsTableColumnId.Venue]: ContentId.Venue,
  [EventsTableColumnId.Location]: ContentId.Location,
  [EventsTableColumnId.Date]: ContentId.EventDate,
  [EventsTableColumnId.TotalQty]: ContentId.TotalQty,
  [EventsTableColumnId.SoldQty]: ContentId.SoldQty,
  [EventsTableColumnId.ActualSTR]: ContentId.SellThroughRate,
  [EventsTableColumnId.Revenue]: ContentId.SoldProceeds,
  [EventsTableColumnId.SoldCost]: ContentId.SoldCost,
  [EventsTableColumnId.Profit]: ContentId.SoldProfit,
  [EventsTableColumnId.LiftPercentage]: ContentId.LiftPercentage,
  [EventsTableColumnId.ATP]: ContentId.SoldAverageTicketPrice,
  [EventsTableColumnId.ListedQty]: ContentId.ListedQty,
  [EventsTableColumnId.ListedAtp]: ContentId.ListedAverageTicketPrice,
  [EventsTableColumnId.UnsoldQty]: ContentId.UnsoldQty,
  [EventsTableColumnId.Action]: ContentId.Actions,
  [EventsTableColumnId.UnsoldProceeds]: ContentId.UnsoldProceeds,
  [EventsTableColumnId.UnsoldCost]: ContentId.UnsoldCost,
  [EventsTableColumnId.TotalCost]: ContentId.TotalCost,
  [EventsTableColumnId.LastPriceUpdatedDate]: ContentId.LastPriceUpdatedDate,
  [EventsTableColumnId.LastReviewedDate]: ContentId.LastReviewed,
  [EventsTableColumnId.BoostRemainingBudget]: ContentId.BoostRemainingBudget,
};

export const SALE_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  Exclude<SalesTableColumnId, SalesTableColumnId.Marketplace>,
  ContentId
> = {
  [SalesTableColumnId.Checkbox]: ContentId.Checkbox,
  [SalesTableColumnId.Actions]: ContentId.Actions,
  [SalesTableColumnId.InHandDate]: ContentId.InHandDate,
  [SalesTableColumnId.OrderDate]: ContentId.SaleDate,
  [SalesTableColumnId.Proceeds]: ContentId.SoldProceeds,
  [SalesTableColumnId.QuantitySold]: ContentId.SoldQty,
  [SalesTableColumnId.Sale]: ContentId.Sale,
  [SalesTableColumnId.Seating]: ContentId.Seating,
  [SalesTableColumnId.Row]: ContentId.Row,
  [SalesTableColumnId.Seats]: ContentId.Seats,
  [SalesTableColumnId.Status]: ContentId.SaleStatus,
  [SalesTableColumnId.TicketType]: ContentId.Ticket,
  [SalesTableColumnId.SoldTicketCost]: ContentId.SoldCost,
  [SalesTableColumnId.Charges]: ContentId.Charges,
  [SalesTableColumnId.Credits]: ContentId.Credits,
  [SalesTableColumnId.PandL]: ContentId.PandL,
  [SalesTableColumnId.Margin]: ContentId.Margin,
  [SalesTableColumnId.PurchaseCreatedBy]: ContentId.POCreatedBy,
  [SalesTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
  [SalesTableColumnId.PurchaseDate]: ContentId.PoDate,
  [SalesTableColumnId.PaymentState]: ContentId.PayState,
  [SalesTableColumnId.PaymentReceived]: ContentId.PayRec,
  [SalesTableColumnId.PaymentReferenceId]: ContentId.PayRef,
  [SalesTableColumnId.FulfillmentDate]: ContentId.FulfillmentDate,
  [SalesTableColumnId.AutoFulfill]: ContentId.AutoFulfill,
  [SalesTableColumnId.VendorOrderId]: ContentId.ExternalPurchaseIdAbbreviated,
  [SalesTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [SalesTableColumnId.OriginatedBy]: ContentId.OriginatedBy,
  [SalesTableColumnId.TotalPaymentsAmount]: ContentId.PaymentAmount,
  [SalesTableColumnId.TotalConvertedPaymentsAmount]:
    ContentId.ConvertedPaymentAmount,
  [SalesTableColumnId.WastedQuantity]: ContentId.WastedQty,
  [SalesTableColumnId.InternalNotes]: ContentId.PrivateNote,
  [SalesTableColumnId.SeatTraits]: ContentId.SeatTraits,
  [SalesTableColumnId.ConsigneeSellerAccountId]: ContentId.Account,
};

export const SALE_TABLE_V2_COLUMN_ID_TO_CONTENT_ID: Record<
  SalesTableColumnId,
  ContentId
> = {
  [SalesTableColumnId.Checkbox]: ContentId.Checkbox,
  [SalesTableColumnId.Actions]: ContentId.Actions,
  [SalesTableColumnId.InHandDate]: ContentId.InHandDate,
  [SalesTableColumnId.OrderDate]: ContentId.SaleDate,
  [SalesTableColumnId.Proceeds]: ContentId.SoldProceeds,
  [SalesTableColumnId.QuantitySold]: ContentId.SoldQty,
  [SalesTableColumnId.Sale]: ContentId.SaleId,
  [SalesTableColumnId.Seating]: ContentId.Seating,
  [SalesTableColumnId.Row]: ContentId.Row,
  [SalesTableColumnId.Seats]: ContentId.Seats,
  [SalesTableColumnId.Status]: ContentId.SaleStatus,
  [SalesTableColumnId.TicketType]: ContentId.Ticket,
  [SalesTableColumnId.SoldTicketCost]: ContentId.SoldCost,
  [SalesTableColumnId.Charges]: ContentId.Charges,
  [SalesTableColumnId.Credits]: ContentId.Credits,
  [SalesTableColumnId.PandL]: ContentId.PandL,
  [SalesTableColumnId.Margin]: ContentId.Margin,
  [SalesTableColumnId.PurchaseCreatedBy]: ContentId.POCreatedBy,
  [SalesTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
  [SalesTableColumnId.PurchaseDate]: ContentId.PoDate,
  [SalesTableColumnId.PaymentState]: ContentId.PaymentState,
  [SalesTableColumnId.PaymentReceived]: ContentId.PaymentReceived,
  [SalesTableColumnId.PaymentReferenceId]: ContentId.PaymentReference,
  [SalesTableColumnId.FulfillmentDate]: ContentId.FulfillmentDate,
  [SalesTableColumnId.AutoFulfill]: ContentId.AutoFulfill,
  [SalesTableColumnId.VendorOrderId]: ContentId.ExternalPurchaseIdAbbreviated,
  [SalesTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [SalesTableColumnId.OriginatedBy]: ContentId.OriginatedBy,
  [SalesTableColumnId.TotalPaymentsAmount]: ContentId.PaymentAmount,
  [SalesTableColumnId.TotalConvertedPaymentsAmount]:
    ContentId.ConvertedPaymentAmount,
  [SalesTableColumnId.WastedQuantity]: ContentId.WastedQty,
  [SalesTableColumnId.InternalNotes]: ContentId.PrivateNote,
  [SalesTableColumnId.SeatTraits]: ContentId.SeatTraits,
  [SalesTableColumnId.ConsigneeSellerAccountId]: ContentId.Account,
  [SalesTableColumnId.Marketplace]: ContentId.Marketplace,
};

export const SALE_TABLE_FLATTENED_COLUMN_ID_TO_CONTENT_ID: Record<
  SalesTableFlattenedColumnId,
  ContentId
> = {
  [SalesTableFlattenedColumnId.Event]: ContentId.Event,
  [SalesTableFlattenedColumnId.Venue]: ContentId.Venue,
  [SalesTableFlattenedColumnId.Location]: ContentId.Location,
  [SalesTableFlattenedColumnId.EventDate]: ContentId.EventDate,
};

export const RECENT_SALES_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  RecentSalesTableColumnId,
  ContentId
> = {
  [RecentSalesTableColumnId.EventName]: ContentId.Event,
  [RecentSalesTableColumnId.EventDate]: ContentId.EventDate,
  [RecentSalesTableColumnId.Seating]: ContentId.Seating,
  [RecentSalesTableColumnId.Venue]: ContentId.Venue,
  [RecentSalesTableColumnId.Status]: ContentId.SaleStatus,
  [RecentSalesTableColumnId.Marketplace]: ContentId.Marketplace,
  [RecentSalesTableColumnId.SoldQuantityTicketType]: ContentId.TicketType,
  [RecentSalesTableColumnId.SaleId]: ContentId.SaleId,
  [RecentSalesTableColumnId.Proceeds]: ContentId.Proceeds,
  [RecentSalesTableColumnId.ProceedsPerTicket]: ContentId.ProceedsPerTicket,
  [RecentSalesTableColumnId.PandL]: ContentId.PandL,
  [RecentSalesTableColumnId.Margin]: ContentId.Margin,
  [RecentSalesTableColumnId.Actions]: ContentId.Actions,
  [RecentSalesTableColumnId.OrderDate]: ContentId.SaleDate,
  [RecentSalesTableColumnId.InHandDate]: ContentId.InHandDate,
  [RecentSalesTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
};

export const SALE_REPORT_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  SalesReportTableColumnId,
  ContentId
> = {
  [SalesReportTableColumnId.Performer]: ContentId.Performer,
  [SalesReportTableColumnId.Venue]: ContentId.Venue,
  [SalesReportTableColumnId.Event]: ContentId.EventName,
  [SalesReportTableColumnId.QuantitySold]: ContentId.SoldQty,
  [SalesReportTableColumnId.Proceeds]: ContentId.SoldProceeds,
  [SalesReportTableColumnId.EventGenre]: ContentId.Genre,
  [SalesReportTableColumnId.EventCountry]: ContentId.Country,
  [SalesReportTableColumnId.EventCity]: ContentId.City,
  [SalesReportTableColumnId.SeatingSection]: ContentId.Section,
  [SalesReportTableColumnId.SeatingRow]: ContentId.Row,
  [SalesReportTableColumnId.SaleMarketplace]: ContentId.Marketplace,
  [SalesReportTableColumnId.SaleMonth]: ContentId.Month,
  [SalesReportTableColumnId.SaleWeek]: ContentId.WeekOfYear,
  [SalesReportTableColumnId.SaleDay]: ContentId.Day,
  [SalesReportTableColumnId.SoldTicketCost]: ContentId.SoldCost,
  [SalesReportTableColumnId.Charges]: ContentId.Charges,
  [SalesReportTableColumnId.Credits]: ContentId.Credits,
  [SalesReportTableColumnId.EventId]: ContentId.EventId,
  [SalesReportTableColumnId.Category]: ContentId.Category,
  [SalesReportTableColumnId.EventDate]: ContentId.EventDate,
  [SalesReportTableColumnId.EventStateProvince]: ContentId.StateProvince,
  [SalesReportTableColumnId.SaleId]: ContentId.SaleId,
  [SalesReportTableColumnId.MarketplaceSaleId]: ContentId.ExternalSaleId,
  [SalesReportTableColumnId.Status]: ContentId.SaleStatus,
  [SalesReportTableColumnId.TicketType]: ContentId.Ticket,
  [SalesReportTableColumnId.InHandDate]: ContentId.InHandDate,
  [SalesReportTableColumnId.PaymentState]: ContentId.PayState,
  [SalesReportTableColumnId.PaymentReceived]: ContentId.PayRec,
  [SalesReportTableColumnId.PaymentReferenceId]: ContentId.PayRef,
  [SalesReportTableColumnId.Fulfiller]: ContentId.FulfilledBy,
  [SalesReportTableColumnId.PurchaseId]: ContentId.PoId,
  [SalesReportTableColumnId.PurchasedBy]: ContentId.PurchasedBy,
  [SalesReportTableColumnId.Vendor]: ContentId.Vendor,
  [SalesReportTableColumnId.SeatingSeats]: ContentId.Seats,
  [SalesReportTableColumnId.OrderDate]: ContentId.SaleDate,
  [SalesReportTableColumnId.PricedBy]: ContentId.PricedBy,
  [SalesReportTableColumnId.CurrencyCode]: ContentId.Currency,
  [SalesReportTableColumnId.PaymentDate]: ContentId.PaymentDate,
  [SalesReportTableColumnId.FulfillmentDate]: ContentId.FulfillmentDate,
  [SalesReportTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [SalesReportTableColumnId.InternalNotes]: ContentId.Notes,
  [SalesReportTableColumnId.CancellationDate]: ContentId.CancellationDate,
  [SalesReportTableColumnId.OutstandingBalance]: ContentId.OutstandingBalance,
  [SalesReportTableColumnId.PandL]: ContentId.PandL,
  [SalesReportTableColumnId.Margin]: ContentId.Margin,
  [SalesReportTableColumnId.PurchaseCreatedBy]: ContentId.POCreatedBy,
  [SalesReportTableColumnId.PurchaseDate]: ContentId.PoDate,
  [SalesReportTableColumnId.TicketId]: ContentId.TicketId,
  [SalesReportTableColumnId.TicketGroupId]: ContentId.TicketGroupId,
  [SalesReportTableColumnId.CommissionUser]: ContentId.Commissioner,
  [SalesReportTableColumnId.CommissionPercent]: ContentId.Commission,
  [SalesReportTableColumnId.CommissionShare]: ContentId.Share,
  [SalesReportTableColumnId.MarketplacePaymentTerms]:
    ContentId.MarketplacePaymentTerms,
};

export const ADGROUPS_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  AdGroupsTableColumnId,
  ContentId
> = {
  [AdGroupsTableColumnId.Name]: ContentId.Name,
  [AdGroupsTableColumnId.State]: ContentId.State,
  [AdGroupsTableColumnId.BaseBid]: ContentId.BaseBid,
  [AdGroupsTableColumnId.MaxBid]: ContentId.MaxBid,
  [AdGroupsTableColumnId.DailyBudget]: ContentId.DailyBudget,
  [AdGroupsTableColumnId.Genre]: ContentId.Genre,
  [AdGroupsTableColumnId.Performer]: ContentId.Performer,
  [AdGroupsTableColumnId.Venue]: ContentId.Venue,
  [AdGroupsTableColumnId.Section]: ContentId.Section,
  [AdGroupsTableColumnId.TicketClass]: ContentId.TicketClass,
  [AdGroupsTableColumnId.Listing]: ContentId.Listing,
  [AdGroupsTableColumnId.Event]: ContentId.Event,
  [AdGroupsTableColumnId.BidModifier]: ContentId.BidModifier,
  [AdGroupsTableColumnId.AdSpend]: ContentId.AdSpend,
  [AdGroupsTableColumnId.SoldProceeds]: ContentId.SoldProceeds,
  [AdGroupsTableColumnId.SoldQty]: ContentId.SoldQty,
  [AdGroupsTableColumnId.Actions]: ContentId.Actions,
};

export const ADCAMPAIGNS_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  AdCampaignsTableColumnId,
  ContentId
> = {
  [AdCampaignsTableColumnId.Name]: ContentId.Name,
  [AdCampaignsTableColumnId.State]: ContentId.State,
  [AdCampaignsTableColumnId.Budget]: ContentId.Budget,
  [AdCampaignsTableColumnId.StartDateTime]: ContentId.StartDateTime,
  [AdCampaignsTableColumnId.EndDateTime]: ContentId.EndDateTime,
  [AdCampaignsTableColumnId.AdSpend]: ContentId.AdSpend,
  [AdCampaignsTableColumnId.SoldProceeds]: ContentId.SoldProceeds,
  [AdCampaignsTableColumnId.SoldQty]: ContentId.SoldQty,
  [AdCampaignsTableColumnId.Actions]: ContentId.Actions,
};

export const CAMPAIGNS_TABLE_V2_COLUMN_ID_TO_CONTENT_ID: Record<
  CampaignsTableColumnId,
  ContentId | string
> = {
  [CampaignsTableColumnId.Campaign]: ContentId.CampaignName,
  [CampaignsTableColumnId.EventName]: ContentId.Event,
  [CampaignsTableColumnId.EventDate]: ContentId.EventDate,
  [CampaignsTableColumnId.StartDate]: ContentId.StartDateTime,
  [CampaignsTableColumnId.StartTime]: ContentId.Time,
  [CampaignsTableColumnId.EndDate]: ContentId.EndDateTime,
  [CampaignsTableColumnId.PotentialRevenue]: ContentId.PotentialRevenue,
  [CampaignsTableColumnId.Revenue]: ContentId.Revenue,
  [CampaignsTableColumnId.Spend]: ContentId.AdSpend,
  [CampaignsTableColumnId.Roas]: 'ROAS',
  [CampaignsTableColumnId.PotentialSales]: ContentId.PotentialSales,
  [CampaignsTableColumnId.SalesCount]: ContentId.Sales,
  [CampaignsTableColumnId.HistoricPotentialImpressions]:
    ContentId.HistoricPotentialImpressions,
  [CampaignsTableColumnId.ActualImpressions]: ContentId.ActualImpressions,
  [CampaignsTableColumnId.ImpressionShare]: ContentId.ImpressionShare,
  [CampaignsTableColumnId.Clicks]: ContentId.Clicks,
  [CampaignsTableColumnId.Cpc]: 'CPC', // CPC uses ad spend label
  [CampaignsTableColumnId.Budget]: ContentId.Budget,
  [CampaignsTableColumnId.BudgetRemaining]: ContentId.Remaining,
  [CampaignsTableColumnId.Status]: ContentId.Status,
  [CampaignsTableColumnId.Strategy]: ContentId.BoostStrategyColumnHeader,
  [CampaignsTableColumnId.Target]: ContentId.Target,
  [CampaignsTableColumnId.Actions]: ContentId.Actions,
};

export const FLIGHTS_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  FlightsTableColumnId,
  ContentId | string
> = {
  [FlightsTableColumnId.StartDate]: ContentId.StartDateTime,
  [FlightsTableColumnId.Duration]: ContentId.Duration,
  [FlightsTableColumnId.Campaign]: ContentId.CampaignName,
  [FlightsTableColumnId.EventName]: ContentId.Event,
  [FlightsTableColumnId.EventDate]: ContentId.EventDate,
  [FlightsTableColumnId.PotentialRevenue]: ContentId.PotentialRevenue,
  [FlightsTableColumnId.Revenue]: ContentId.Revenue,
  [FlightsTableColumnId.Spend]: ContentId.AdSpend,
  [FlightsTableColumnId.Roas]: 'ROAS',
  [FlightsTableColumnId.PotentialSales]: ContentId.PotentialSales,
  [FlightsTableColumnId.SalesCount]: ContentId.Sales,
  [FlightsTableColumnId.HistoricPotentialImpressions]:
    ContentId.HistoricPotentialImpressions,
  [FlightsTableColumnId.ActualImpressions]: ContentId.ActualImpressions,
  [FlightsTableColumnId.ImpressionShare]: ContentId.ImpressionShare,
  [FlightsTableColumnId.Clicks]: ContentId.Clicks,
  [FlightsTableColumnId.Cpc]: 'CPC',
  [FlightsTableColumnId.Budget]: ContentId.Budget,
  [FlightsTableColumnId.BudgetRemaining]: ContentId.Remaining,
  [FlightsTableColumnId.Status]: ContentId.Status,
  [FlightsTableColumnId.Target]: ContentId.Target,
  [FlightsTableColumnId.Actions]: ContentId.Actions,
};

export const PURCHASE_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  | Exclude<PurchasesTableColumnId, PurchasesTableColumnId.Vendor>
  | PurchaseTableColumnGroupId,
  ContentId | string
> = {
  [PurchasesTableColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [PurchasesTableColumnId.Checkbox]: ContentId.Checkbox,
  [PurchasesTableColumnId.AccordianToggle]: ContentId.AccordianToggle,
  [PurchasesTableColumnId.Id]: ContentId.Id,
  [PurchasesTableColumnId.Payment]: ContentId.PmtMethod,
  [PurchasesTableColumnId.PaymentStatus]: ContentId.PmtState,
  [PurchasesTableColumnId.PurchaseDate]: ContentId.PoDate,
  [PurchasesTableColumnId.QualityControlState]: 'QC',
  [PurchasesTableColumnId.TotalCost]: ContentId.TotalCost,
  [PurchasesTableColumnId.UnitCost]: ContentId.UnitCost,
  [PurchasesTableColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [PurchasesTableColumnId.Tickets]: ContentId.QuantityAbbreviated,
  [PurchasesTableColumnId.Orders]: ContentId.TicketGroups,
  [PurchasesTableColumnId.Shipment]: ContentId.Delivery,
  [PurchasesTableColumnId.Cost]: ContentId.TotalCost,
  [PurchasesTableColumnId.Actions]: ContentId.Actions,
  [PurchasesTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [PurchasesTableColumnId.CreatedBy]: ContentId.CreatedBy,
  [PurchasesTableColumnId.Event]: ContentId.Event,
  [PurchasesTableColumnId.Venue]: ContentId.Venue,
  [PurchasesTableColumnId.EventDate]: ContentId.EventDate,
  [PurchasesTableColumnId.Seating]: ContentId.Seating,
  [PurchasesTableColumnId.Row]: ContentId.Row,
  [PurchasesTableColumnId.Seats]: ContentId.Seats,
  [PurchaseTableColumnGroupId.TicketGroup]: ContentId.TicketGroup,
  [PurchasesTableColumnId.TotalPayment]: ContentId.PmtAmount,
  [PurchasesTableColumnId.TotalConvertedPayment]: ContentId.ConvPmtAmt,
  [PurchasesTableColumnId.PaymentConversionRate]: ContentId.FXRate,
  [PurchasesTableColumnId.Commissions]: ContentId.Commissions,
  [PurchasesTableColumnId.SeatTraits]: ContentId.SeatTraits,
  [PurchasesTableColumnId.ConsigneeSellerAccountId]: ContentId.Account,
  [PurchasesTableColumnId.OutstandingBalance]: ContentId.OutstandingBalance,
  [PurchasesTableColumnId.FaceValueCost]: ContentId.FaceValueCost,
};

export const PURCHASE_TABLE_V2_COLUMN_ID_TO_CONTENT_ID: Record<
  PurchasesTableColumnId | PurchaseTableColumnGroupId,
  ContentId | string
> = {
  [PurchasesTableColumnId.BuyerUserId]: ContentId.PurchasedBy,
  [PurchasesTableColumnId.Checkbox]: ContentId.Checkbox,
  [PurchasesTableColumnId.AccordianToggle]: ContentId.AccordianToggle,
  [PurchasesTableColumnId.Id]: ContentId.Id,
  [PurchasesTableColumnId.Payment]: ContentId.PaymentMethod,
  [PurchasesTableColumnId.PaymentStatus]: ContentId.PaymentState,
  [PurchasesTableColumnId.PurchaseDate]: ContentId.PoDate,
  [PurchasesTableColumnId.QualityControlState]: 'QC',
  [PurchasesTableColumnId.TotalCost]: ContentId.TotalCost,
  [PurchasesTableColumnId.UnitCost]: ContentId.UnitCost,
  [PurchasesTableColumnId.VendorOrderId]:
    ContentId.ExternalPurchaseIdAbbreviated,
  [PurchasesTableColumnId.Vendor]: ContentId.Vendor,
  [PurchasesTableColumnId.Tickets]: ContentId.QuantityAbbreviated,
  [PurchasesTableColumnId.Orders]: ContentId.TicketGroups,
  [PurchasesTableColumnId.Shipment]: ContentId.Delivery,
  [PurchasesTableColumnId.Cost]: ContentId.TotalCost,
  [PurchasesTableColumnId.Actions]: ContentId.Actions,
  [PurchasesTableColumnId.VendorAccountEmail]: ContentId.VendorAccount,
  [PurchasesTableColumnId.CreatedBy]: ContentId.CreatedBy,
  [PurchasesTableColumnId.Event]: ContentId.Event,
  [PurchasesTableColumnId.Venue]: ContentId.Venue,
  [PurchasesTableColumnId.EventDate]: ContentId.EventDate,
  [PurchasesTableColumnId.Seating]: ContentId.Seating,
  [PurchasesTableColumnId.Row]: ContentId.Row,
  [PurchasesTableColumnId.Seats]: ContentId.Seats,
  [PurchaseTableColumnGroupId.TicketGroup]: ContentId.TicketGroup,
  [PurchasesTableColumnId.TotalPayment]: ContentId.PaymentAmount,
  [PurchasesTableColumnId.TotalConvertedPayment]:
    ContentId.ConvertedPaymentsAmount,
  [PurchasesTableColumnId.PaymentConversionRate]: ContentId.FXRate,
  [PurchasesTableColumnId.Commissions]: ContentId.Commissions,
  [PurchasesTableColumnId.SeatTraits]: ContentId.SeatTraits,
  [PurchasesTableColumnId.ConsigneeSellerAccountId]: ContentId.Account,
  [PurchasesTableColumnId.OutstandingBalance]: ContentId.OutstandingBalance,
  [PurchasesTableColumnId.FaceValueCost]: ContentId.FaceValueCost,
};

export const PAYMENTS_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  MarketplacePaymentsTableColumnId,
  ContentId | string
> = {
  [MarketplacePaymentsTableColumnId.PaymentReferenceID]: ContentId.ReferenceId,
  [MarketplacePaymentsTableColumnId.ExternalPaymentID]: ContentId.PaymentId,
  [MarketplacePaymentsTableColumnId.PaymentAmount]: ContentId.PaymentAmount,
  [MarketplacePaymentsTableColumnId.PaymentDate]: ContentId.PaymentDate,
  [MarketplacePaymentsTableColumnId.State]: ContentId.State,
  [MarketplacePaymentsTableColumnId.CreditAmount]: ContentId.CreditAmount,
  [MarketplacePaymentsTableColumnId.ProceedsAmount]: ContentId.ProceedsAmount,
  [MarketplacePaymentsTableColumnId.ChargeAmount]: ContentId.ChargeAmount,
  [MarketplacePaymentsTableColumnId.Marketplace]: ContentId.Marketplace,
  [MarketplacePaymentsTableColumnId.ConvertedPaymentsAmount]:
    ContentId.ConvertedPaymentsAmount,
  [MarketplacePaymentsTableColumnId.Actions]: ContentId.Actions,
};

export const ON_SALE_EVENT_TABLE_COLUMN_ID_CONTENT_ID: Record<
  OnSaleEventTableColumnId,
  ContentId | string
> = {
  [OnSaleEventTableColumnId.Checkbox]: ContentId.Checkbox,
  [OnSaleEventTableColumnId.Event]: ContentId.EventName,
  [OnSaleEventTableColumnId.InferredPrimary]: ContentId.Primary,
  [OnSaleEventTableColumnId.Venue]: ContentId.Venue,
  [OnSaleEventTableColumnId.Capacity]: ContentId.Capacity,
  [OnSaleEventTableColumnId.Location]: ContentId.Location,
  [OnSaleEventTableColumnId.OnSaleDate]: ContentId.OnSaleDate,
  [OnSaleEventTableColumnId.RawPreSaleDate]: ContentId.PreSaleDate,
  [OnSaleEventTableColumnId.Date]: ContentId.EventDate,
  [OnSaleEventTableColumnId.ListingCount]: ContentId.ListingQty,
  [OnSaleEventTableColumnId.TicketCount]: ContentId.TicketQty,
  [OnSaleEventTableColumnId.UnitNetProceedsMin]: ContentId.PriceMin,
  [OnSaleEventTableColumnId.UnitNetProceedsP25]: ContentId.PriceP25,
  [OnSaleEventTableColumnId.UnitNetProceedsP50]: ContentId.PriceP50,
  [OnSaleEventTableColumnId.RecentVisits]: ContentId.RecentVisits,
  // TODO: @tianxu Temporary hardcode the texts, need to make the map support formatted contents
  [OnSaleEventTableColumnId.VisitsLastHour]: 'Visits L1H',
  [OnSaleEventTableColumnId.VisitsLastDay]: 'Visits L24H',
  [OnSaleEventTableColumnId.VisitsLast3Days]: 'Visits L3D',
  [OnSaleEventTableColumnId.TransactionsLastHour]: 'Visits L7H',
  [OnSaleEventTableColumnId.VisitsLast7Days]: 'Trans. L1H',
  [OnSaleEventTableColumnId.TransactionsLastDay]: 'Trans. L24H',
  [OnSaleEventTableColumnId.TransactionsLast3Days]: 'Trans. L3D',
  [OnSaleEventTableColumnId.TransactionsLast7Days]: 'Trans. L7D',
  [OnSaleEventTableColumnId.Action]: ContentId.Actions,
};

export type ListingFormulaFieldsListing =
  | ListingFormulaFields.unsoldQuantity
  | ListingFormulaFields.availableQuantity
  | ListingFormulaFields.ticketCount
  | ListingFormulaFields.unitCost
  | ListingFormulaFields.listPrice
  | ListingFormulaFields.allInPrice
  | ListingFormulaFields.netProceedsFloor
  | ListingFormulaFields.netProceedsCeiling
  | ListingFormulaFields.websiteFloor
  | ListingFormulaFields.websiteCeiling
  | ListingFormulaFields.undercutAbsoluteAmount
  | ListingFormulaFields.undercutRelativeAmount
  | ListingFormulaFields.compListingFloor
  | ListingFormulaFields.compListingCeiling
  | ListingFormulaFields.shownQuantity
  | ListingFormulaFields.soldCost
  | ListingFormulaFields.soldQuantity
  | ListingFormulaFields.totalCost
  | ListingFormulaFields.unsoldCost
  | ListingFormulaFields.unsoldProceeds
  | ListingFormulaFields.wastedCost
  | ListingFormulaFields.wastedTickets;

export const LISTING_FORMULA_FIELDS_TO_CID: Record<
  ListingFormulaFieldsListing,
  ContentId
> = {
  ['unsoldQuantity']: ContentId.Unsold,
  ['availableQuantity']: ContentId.Remaining,
  ['ticketCount']: ContentId.Original,
  ['unitCost']: ContentId.UnitCost,
  ['listPrice']: ContentId.Proceeds,
  ['allInPrice']: ContentId.Price,
  ['netProceedsFloor']: ContentId.ProceedsFloor,
  ['netProceedsCeiling']: ContentId.ProceedsCeiling,
  ['websiteFloor']: ContentId.Price,
  ['websiteCeiling']: ContentId.WebsiteCeiling,
  ['undercutAbsoluteAmount']: ContentId.UndercutAbsoluteAmount,
  ['undercutRelativeAmount']: ContentId.UndercutRelativeAmount,
  ['compListingFloor']: ContentId.CompListingFloor,
  ['compListingCeiling']: ContentId.CompListingCeiling,
  ['soldQuantity']: ContentId.SoldQty,
  ['soldCost']: ContentId.SoldCost,
  ['unsoldCost']: ContentId.UnsoldCost,
  ['shownQuantity']: ContentId.ShownQuantity,
  ['totalCost']: ContentId.TotalCost,
  ['unsoldProceeds']: ContentId.UnsoldProceeds,
  ['wastedCost']: ContentId.WastedCost,
  ['wastedTickets']: ContentId.WastedTickets,
};

export type ListingFormulaFieldsListingReportMetrics =
  | ListingFormulaFields.availableQuantity
  | ListingFormulaFields.ticketCount
  | ListingFormulaFields.unitCost
  | ListingFormulaFields.listPrice
  | ListingFormulaFields.allInPrice
  | ListingFormulaFields.soldQuantity
  | ListingFormulaFields.soldCost
  | ListingFormulaFields.unsoldCost
  | ListingFormulaFields.soldProceeds;

export const LISTING_REPORT_FORMULA_FIELDS_TO_CID: Record<
  ListingFormulaFieldsListingReportMetrics,
  ContentId
> = {
  ['availableQuantity']: ContentId.UnsoldQty,
  ['soldQuantity']: ContentId.SoldQty,
  ['ticketCount']: ContentId.TotalQty,
  ['soldProceeds']: ContentId.SoldProceeds,
  ['listPrice']: ContentId.TotalProceeds,
  ['allInPrice']: ContentId.Price,
  ['soldCost']: ContentId.SoldCost,
  ['unsoldCost']: ContentId.UnsoldCost,
  ['unitCost']: ContentId.TotalCost,
};

export const SALE_FORMULA_FIELDS_TO_CID: Record<
  keyof SaleFormulaFields,
  ContentId
> = {
  ['quantitySold']: ContentId.SoldQty,
  ['totalNetProceeds']: ContentId.SoldProceeds,
  ['charges']: ContentId.Charges,
  ['credits']: ContentId.Credits,
  ['soldTicketCost']: ContentId.SoldCost,
  ['pandL']: ContentId.PandL,
  ['margin']: ContentId.Margin,
};

export const PURCHASE_FORMULA_FIELDS_TO_CID: Record<
  keyof PurchaseFormulaFields,
  ContentId
> = {
  ['ticketCount']: ContentId.QuantityAbbreviated,
  ['unitCost']: ContentId.UnitCost,
  ['totalCost']: ContentId.TotalCost,
  ['totalPayment']: ContentId.PmtAmount,
};

export const EVENTS_FORMULA_FIELDS_TO_CID: Record<string, ContentId> = {
  totalListedQuantity: ContentId.ListedQty,
  totalSoldQuantity: ContentId.SoldQty,
  totalUnsoldQuantity: ContentId.UnsoldQty,
  totalTicketQuantity: ContentId.TotalQty,
  listedAtp: ContentId.ListedAverageTicketPrice,
  totalAtp: ContentId.SoldAverageTicketPrice,
  revenue: ContentId.SoldProceeds,
  totalSoldCost: ContentId.SoldCost,
  totalGrossProfit: ContentId.SoldProfit,
  actualStr: ContentId.SellThroughRate,
  liftPercentage: ContentId.LiftPercentage,
  totalCost: ContentId.TotalCost,
  totalUnsoldCost: ContentId.UnsoldCost,
  totalUnsoldListPrice: ContentId.UnsoldProceeds,
};

export const LISTING_GROUPING_TO_CID: Record<GroupingType, ContentId> = {
  [GroupingType.Custom]: ContentId.Custom,
  [GroupingType.Section]: ContentId.Section,
  [GroupingType.Zone]: ContentId.Zone,
  [GroupingType.Row]: ContentId.Row,
  [GroupingType.SeatScore]: ContentId.SeatScore,
  [GroupingType.Quantity]: ContentId.UnsoldQuantity,
  [GroupingType.UnitCost]: ContentId.UnitCost,
  [GroupingType.None]: ContentId.None,
};

export const BUCKET_OPTIONS_TO_CID: Record<BucketType, ContentId> = {
  [BucketType.None]: ContentId.None,
  [BucketType.Clusters]: ContentId.Clusters,
  [BucketType.SameSize]: ContentId.SameSize,
};

export const NOTIFICATION_TYPE_TO_CID: Record<
  NotificationType,
  ContentId | FormatContentId
> = {
  [NotificationType.SaleNew]: ContentId.NotificationTypeSaleNew,
  [NotificationType.SaleFulfilmentFailed]:
    ContentId.NotificationTypeSaleFulfilmentFailed,
  [NotificationType.SaleMarketplaceCancelled]:
    ContentId.NotificationTypeSaleMarketplaceCancelled,
  [NotificationType.ListingHideSeatsFailed]:
    ContentId.NotificationTypeListingHideSeatsFailed,
  [NotificationType.ListingUpdateAllInPriceFailed]:
    FormatContentId.NotificationTypeListingUpdateAllInPriceFailed,
  [NotificationType.ListingUpdateInHandDateFailed]:
    FormatContentId.NotificationTypeListingUpdateInHandDateFailed,
  [NotificationType.ListingUpdateSplitTypeFailed]:
    FormatContentId.NotificationTypeListingUpdateSplitTypeFailed,
  [NotificationType.ListingUpdateDeliveryTypeFailed]:
    ContentId.NotificationTypeListingUpdateDeliveryTypeFailed,
  [NotificationType.ListingUpdateUnitNetProceedsFailed]:
    FormatContentId.NotificationTypeListingUpdateUnitNetProceedsFailed,
  [NotificationType.ListingBroadcastFailed]:
    FormatContentId.NotificationTypeListingBroadcastFailed,
  [NotificationType.ListingUnbroadcastFailed]:
    FormatContentId.NotificationTypeListingUnbroadcastFailed,
  [NotificationType.ListingMergeFailed]:
    ContentId.NotificationTypeListingMergeFailed,
  [NotificationType.ListingSplitFailed]:
    ContentId.NotificationTypeListingSplitFailed,
  [NotificationType.ListingPriceUpdate]:
    ContentId.NotificationTypeListingPriceUpdate,
  [NotificationType.AutopriceBelowFloor]:
    ContentId.NotificationTypeAutopriceBelowFloor,
  [NotificationType.AutopriceInsufficientCompListings]:
    ContentId.NotificationTypeAutopriceInsufficientCompListings,
  [NotificationType.AutopriceFirebrake]:
    ContentId.NotificationTypeAutopriceFirebrake,
  [NotificationType.SellerSupportCaseNewReply]:
    FormatContentId.NotificationTypeSellerSupportCaseNewReply,
};

export const ACTION_OUTBOX_ENTITY_TYPE_TO_CID: Record<
  ActionOutboxEntityType,
  ContentId
> = {
  [ActionOutboxEntityType.Listing]: ContentId.Listing,
  [ActionOutboxEntityType.Sale]: ContentId.Sale,
  [ActionOutboxEntityType.Purchase]: ContentId.Purchase,
  [ActionOutboxEntityType.SellerSupportCase]: ContentId.SellerSupportCase,
  [ActionOutboxEntityType.Document]: ContentId.Document,
  [ActionOutboxEntityType.SellerEvent]: ContentId.Event,
  [ActionOutboxEntityType.InboundEmail]: ContentId.Email,
  [ActionOutboxEntityType.TicketGroup]: ContentId.TicketGroup,
};

export const ACTIVITY_LOG_STATE_TO_CID: Record<
  MarketplaceOperationResultState,
  ContentId
> = {
  [MarketplaceOperationResultState.Succeeded]: ContentId.Succeeded,
  [MarketplaceOperationResultState.FailedAndRequiresSellerAction]:
    ContentId.FailedAndRequiresSellerAction,
  [MarketplaceOperationResultState.FailedWithNonRetryableError]:
    ContentId.FailedWithNonRetryableError,
  [MarketplaceOperationResultState.FailedWithRetryableError]:
    ContentId.FailedWithRetryableError,
  [MarketplaceOperationResultState.Skipped]: ContentId.Skipped,
  [MarketplaceOperationResultState.NotImplemented]: ContentId.NotImplemented,
};

export const UNDERCUT_MODE_TO_CID: Record<AutoPricingUndercutMode, ContentId> =
  {
    [AutoPricingUndercutMode.Simple]: ContentId.Simple,
    [AutoPricingUndercutMode.RowExtrapolation]: ContentId.RowExtrapolation,
    [AutoPricingUndercutMode.Deal]: ContentId.Deal,
    [AutoPricingUndercutMode.AverageOfCheapestListings]:
      ContentId.AvgOfTheNthCheapestListings,
  };

export const UNDERCUT_MODE_TO_FLUENT_CID: Record<
  AutoPricingUndercutMode,
  ContentId
> = {
  [AutoPricingUndercutMode.Simple]: ContentId.Cheapest,
  [AutoPricingUndercutMode.RowExtrapolation]: ContentId.BestRowExtrapolation,
  [AutoPricingUndercutMode.Deal]: ContentId.BestDealScore,
  [AutoPricingUndercutMode.AverageOfCheapestListings]:
    ContentId.AvgOfTheNthCheapestListings,
};

export const SIMPLIFIED_UNDERCUT_MODE_TO_CID: Record<
  SimplifiedUndercutMode,
  ContentId
> = {
  [SimplifiedUndercutMode.CheapestListing]: ContentId.CheapestListing,
  [SimplifiedUndercutMode.NthCheapestListing]: ContentId.NthCheapestListing,
  [SimplifiedUndercutMode.AvgOfNthCheapestListings]:
    ContentId.AvgOfTheNCheapestListings,
};

export const UNDERCUT_REFERENCE_LISTING_POSITION_TO_CID: Record<
  number,
  ContentId
> = {
  1: ContentId['1st'],
  2: ContentId['2nd'],
  3: ContentId['3rd'],
  4: ContentId['4th'],
  5: ContentId['5th'],
  6: ContentId['6th'],
  7: ContentId['7th'],
  8: ContentId['8th'],
  9: ContentId['9th'],
  10: ContentId['10th'],
};

export const OUTLIER_MODE_TO_CID: Record<AutoPricingOutlierMode, ContentId> = {
  [AutoPricingOutlierMode.StandardDeviations]: ContentId.StandardDeviations,
  [AutoPricingOutlierMode.KthLowest]: ContentId.Spacing,
  [AutoPricingOutlierMode.SkipLogic]: ContentId.SkipLogic,
};

export const COMP_LISTING_MODE_TO_CID: Record<
  AutoPricingCompListingMode,
  ContentId
> = {
  [AutoPricingCompListingMode.QualityScore]: ContentId.VenueWideQualityScore,
  [AutoPricingCompListingMode.SameSection]:
    ContentId.VenueWideInSectionPriority,
  [AutoPricingCompListingMode.SameZone]: ContentId.Zones,
  [AutoPricingCompListingMode.SameEvent]: ContentId.Events,
  [AutoPricingCompListingMode.ParentListing]: ContentId.ParentListing,
};

export const COMP_LISTING_MODE_TO_FLUENT_CID: Record<
  AutoPricingCompListingMode,
  ContentId
> = {
  [AutoPricingCompListingMode.QualityScore]: ContentId.OfSimilarQuality,
  [AutoPricingCompListingMode.SameSection]: ContentId.InSection,
  [AutoPricingCompListingMode.SameZone]: ContentId.InZone,
  [AutoPricingCompListingMode.SameEvent]: ContentId.ForTheEvent,
  [AutoPricingCompListingMode.ParentListing]: ContentId.InMyGroup,
};

export const COMP_ROWOFFSET_MODE_TO_CID: Record<CompRowOffsetMode, ContentId> =
  {
    [CompRowOffsetMode.Ordinal]: ContentId.Ordinal,
    [CompRowOffsetMode.Text]: ContentId.Text,
  };

export const COMP_ROWOFFSET_MODE_DESCRIPTION_TO_CID: Record<
  CompRowOffsetMode,
  ContentId
> = {
  [CompRowOffsetMode.Ordinal]: ContentId.CompRowOffsetModeDescriptionOrdinal,
  [CompRowOffsetMode.Text]: ContentId.CompRowOffsetModeDescriptionText,
};

export const AUTO_PO_INBOUND_EMAIL_CLASSIFICATION_TYPE_TO_CID: Record<
  AutoPoInboundEmailClassificationType,
  ContentId
> = {
  [AutoPoInboundEmailClassificationType.NewPurchaseOrder]: ContentId.NewOrder,
  [AutoPoInboundEmailClassificationType.ExistingPurchaseOrder]:
    ContentId.ExistingOrder,
  [AutoPoInboundEmailClassificationType.Junk]: ContentId.Junk,
  [AutoPoInboundEmailClassificationType.OneTimePass]: ContentId.OneTimePass,
  [AutoPoInboundEmailClassificationType.Password]: ContentId.Password,
  [AutoPoInboundEmailClassificationType.TicketsAvailable]:
    ContentId.TicketsAvailable,
  [AutoPoInboundEmailClassificationType.PurchaseCancelled]:
    ContentId.PurchaseCancelled,
  [AutoPoInboundEmailClassificationType.EventCancelled]:
    ContentId.EventCancelled,
  [AutoPoInboundEmailClassificationType.EventPostponed]:
    ContentId.EventPostponed,
  [AutoPoInboundEmailClassificationType.EnjoyTheEvent]: ContentId.EnjoyTheEvent,
  [AutoPoInboundEmailClassificationType.TransferSent]: ContentId.TransferSent,
  [AutoPoInboundEmailClassificationType.TransferAccepted]:
    ContentId.TransferAccepted,
  [AutoPoInboundEmailClassificationType.TransferExpired]:
    ContentId.TransferExpired,
  [AutoPoInboundEmailClassificationType.NewSale]: ContentId.NewSale,
  [AutoPoInboundEmailClassificationType.ConfirmationDeadline]:
    ContentId.ConfirmationDeadline,
  [AutoPoInboundEmailClassificationType.ShippingDeadline]:
    ContentId.ShippingDeadline,
  [AutoPoInboundEmailClassificationType.SaleCancelled]: ContentId.SaleCancelled,
  [AutoPoInboundEmailClassificationType.OtherMarketplaceContact]:
    ContentId.OtherMarketplaceContact,
};

export const STANDARD_DEVIATIONS_TO_CID: Record<string, ContentId> = {
  '1': ContentId.VeryAggressive,
  '2': ContentId.AggressiveOption,
  '3': ContentId.NormalOption,
  '4': ContentId.InclusiveOption,
};

export const REPORT_TYPES_TO_CID: Record<ReportTypes, ContentId> = {
  [ReportTypes.Inventory]: ContentId.Inventory,
  [ReportTypes.Sale]: ContentId.Sales,
};

export const INVENTORY_REPORT_WIDGETS_TO_CID: Record<
  ReportWidgetTypesInventory,
  ContentId
> = {
  [ReportWidgetTypesInventory.AverageTicketPrice]:
    ContentId.SoldAverageTicketPrice,
  [ReportWidgetTypesInventory.SalesAndMargin]: ContentId.SalesAndMargin,
  [ReportWidgetTypesInventory.TicketsListedAndSold]:
    ContentId.TicketsListedAndSold,
};

export const REPORT_INVENTORY_GROUP_BY_TO_CID: Record<string, ContentId> = {
  [ReportGroupBy.ListingId]: ContentId.Listing,
  [ReportGroupBy.PurchaseId]: ContentId.Purchase,
  [ReportGroupBy.Performer]: ContentId.Performers,
  [ReportGroupBy.Event]: ContentId.Event,
  [ReportGroupBy.EventGenre]: ContentId.Genre,
  [ReportGroupBy.Venue]: ContentId.Venue,
  [ReportGroupBy.EventCountry]: ContentId.Country,
  [ReportGroupBy.EventCity]: ContentId.City,
  [ReportGroupBy.SeatingSection]: ContentId.Section,
  [ReportGroupBy.SeatingRow]: ContentId.Row,
  [ReportGroupBy.Vendor]: ContentId.Vendor,
  [ReportGroupBy.PricedBy]: ContentId.PricedBy,
  [ReportGroupBy.PurchasedBy]: ContentId.PurchasedBy,
  [ReportGroupBy.FulfilledBy]: ContentId.FulfilledBy,
};

export const REPORT_SALE_GROUP_BY_TO_CID: Record<string, ContentId> = {
  [ReportGroupBy.SaleId]: ContentId.Sale,
  [ReportGroupBy.Performer]: ContentId.Performers,
  [ReportGroupBy.Event]: ContentId.Event,
  [ReportGroupBy.EventGenre]: ContentId.Genre,
  [ReportGroupBy.Venue]: ContentId.Venue,
  [ReportGroupBy.EventCountry]: ContentId.Country,
  [ReportGroupBy.EventCity]: ContentId.City,
  [ReportGroupBy.SeatingSection]: ContentId.Section,
  [ReportGroupBy.SeatingRow]: ContentId.Row,
  [ReportGroupBy.SaleMarketplace]: ContentId.Marketplace,
  [ReportGroupBy.Vendor]: ContentId.Vendor,
  [ReportGroupBy.SaleMonth]: ContentId.Month,
  [ReportGroupBy.SaleWeek]: ContentId.WeekOfYear,
  [ReportGroupBy.SaleDay]: ContentId.Day,
  [ReportGroupBy.PricedBy]: ContentId.PricedBy,
  [ReportGroupBy.PurchasedBy]: ContentId.PurchasedBy,
  [ReportGroupBy.FulfilledBy]: ContentId.FulfilledBy,
};

export const REPORT_IS_SORT_DESCENDING_TO_CID: Record<string, ContentId> = {
  // corresponds to value isSortDescending : boolean
  false: ContentId.AtoZArrow,
  true: ContentId.ZtoAArrow,
};

export const REPORT_IS_SORT_ASCENDING_TO_CID: Record<string, ContentId> = {
  // corresponds to value isSortAsc : boolean
  true: ContentId.AtoZArrow,
  false: ContentId.ZtoAArrow,
};

export const BOOLEAN_OPTIONS_CONTENT: Record<string, string> = {
  true: 'true',
  false: 'false',
};

export const RESTRICT_SELECTION_TYPE_TO_CID: Record<
  RestrictSelectionType,
  ContentId
> = {
  [RestrictSelectionType.SameZone]: ContentId.SameZone,
  [RestrictSelectionType.SpecificSections]: ContentId.SpecificSections,
  [RestrictSelectionType.SameSection]: ContentId.SameSection,
};

export const MARKETPLACE_PAYMENT_TERM_TO_CID: Record<
  MarketplacePaymentTerm,
  ContentId
> = {
  [MarketplacePaymentTerm.PaymentUponSaleConfirmation]:
    ContentId.PaymentUponSaleConfirmation,
  [MarketplacePaymentTerm.PaymentUponDelivery]: ContentId.PaymentUponDelivery,
  [MarketplacePaymentTerm.PaymentPostEvent]: ContentId.PaymentPostEvent,
};

// From https://dev.azure.com/viagogo/Database/_git/viagogo.Database.ProductionDeploys?path=%2Fdb%2FGoldenData%2FAppEventDataManager%2Ftables%2FMappingRejectionReason.sql&_a=contents&version=GBdevelop
// Overrides the MappingRejectionReasonDescription within the table with internationalized content
//
// select	*
// from	GoldenData.AppEventDataManager.MappingRejectionReason
// where	MappingTypeId = 1; -- Event Mapping
export const MAPPING_REJECTION_REASON_ID_TO_CID: Record<string, ContentId> = {
  '1': ContentId.CancelledEvent,
  '2': ContentId.CharityEvent,
  '3': ContentId.DuplicateEventNeedsToBeRescheduled,
  '4': ContentId.DuplicateEventPerformerVenueDateAndTimeMatch,
  '5': ContentId.EventHasPassed,
  '6': ContentId.FreeEvent,
  '7': ContentId.FulfillmentRestrictions,
  '8': ContentId.IncorrectPerfomerOrGrouping,
  '9': ContentId.NotEnoughInformationToCreate,
  '10': ContentId.NotFoundOnPrimary,
  '11': ContentId.PendingPartnerIntegrations,
  '12': ContentId.IncorrectCountryCode,
};

export const EVENT_MAPPING_STATE_FILTER_TO_CID: Record<
  EventMappingStateFilter,
  ContentId
> = {
  [EventMappingStateFilter.All]: ContentId.All,
  [EventMappingStateFilter.Mapped]: ContentId.Mapped,
  [EventMappingStateFilter.Pending]: ContentId.Pending,
  [EventMappingStateFilter.Rejected]: ContentId.Rejected,
};

export const PRICING_FLOOR_CEIL_ADJUSTMENT_TYPE_TO_CID: Record<
  PricingFloorCeilingAdjustmentType,
  ContentId
> = {
  [PricingFloorCeilingAdjustmentType.MarketPrice]: ContentId.MarketPrice,
  [PricingFloorCeilingAdjustmentType.UnitCost]: ContentId.UnitCost,
  [PricingFloorCeilingAdjustmentType.CurrentFloor]: ContentId.CurrentFloor,
};

export const LISTING_PRICE_ADJUSTMENT_TYPE_TO_CID: Record<
  ListingPriceAdjustmentType,
  ContentId
> = {
  [ListingPriceAdjustmentType.CurrentPrice]: ContentId.CurrentPrice,
  [ListingPriceAdjustmentType.UnitCost]: ContentId.UnitCost,
};

export const PRICING_FLOOR_CEIL_ADJUSTMENT_TYPE_TO_WARNING_CID: Record<
  PricingFloorCeilingAdjustmentType,
  ContentId
> = {
  [PricingFloorCeilingAdjustmentType.MarketPrice]:
    ContentId.BulkEditFloorCeilingWarning,
  [PricingFloorCeilingAdjustmentType.UnitCost]:
    ContentId.BulkEditFloorCeilingUnitCostWarning,
  [PricingFloorCeilingAdjustmentType.CurrentFloor]:
    ContentId.BulkEditFloorCeilingCurrentFloorWarning,
};

export const BROADCAST_ERROR_CODE_TO_CID: Record<
  BroadcastErrorCode,
  ContentId
> = {
  [BroadcastErrorCode.BroadcastListing]:
    ContentId.BroadcastErrorCode_BroadcastListing,
  [BroadcastErrorCode.Unknown]: ContentId.BroadcastErrorCode_Unknown,
  [BroadcastErrorCode.UpdatePrice]: ContentId.BroadcastErrorCode_UpdatePrice,
  [BroadcastErrorCode.UpdateTicketType]:
    ContentId.BroadcastErrorCode_UpdateTicketType,
  [BroadcastErrorCode.UpdateSplitType]:
    ContentId.BroadcastErrorCode_UpdateSplitType,
  [BroadcastErrorCode.UpdateInHandDate]:
    ContentId.BroadcastErrorCode_UpdateInHandDate,
  [BroadcastErrorCode.SplitListing]: ContentId.BroadcastErrorCode_SplitListing,
  [BroadcastErrorCode.MergeListing]: ContentId.BroadcastErrorCode_MergeListing,
  [BroadcastErrorCode.UnbroadcastListing]:
    ContentId.BroadcastErrorCode_UnbroadcastListing,
  [BroadcastErrorCode.UpdateQuantity]:
    ContentId.BroadcastErrorCode_UpdateQuantity,
  [BroadcastErrorCode.HideSeats]: ContentId.BroadcastErrorCode_HideSeats,
  [BroadcastErrorCode.UpdateListingNotes]:
    ContentId.BroadcastErrorCode_UpdateListingNotes,
  [BroadcastErrorCode.UpdateSeating]:
    ContentId.BroadcastErrorCode_UpdateSeating,
  [BroadcastErrorCode.MarketplaceResaleRestricted]:
    ContentId.BroadcastErrorCode_MarketplaceResaleRestricted,
  [BroadcastErrorCode.MarketplaceManifestMismatch]:
    ContentId.BroadcastErrorCode_MarketplaceManifestMismatch,
  [BroadcastErrorCode.MarketplacePriceBelowFloor]:
    ContentId.BroadcastErrorCode_MarketplacePriceBelowFloor,
};

export const PAYMENT_METHOD_NAME_REGEX_TO_CONTENT_ID: Record<
  PaymentMethodNameKnownRegex,
  ContentId
> = {
  [PaymentMethodNameKnownRegex.All]: ContentId.All,
  [PaymentMethodNameKnownRegex.AllAmex]: ContentId.AllAmex,
  [PaymentMethodNameKnownRegex.AllVisa]: ContentId.AllVisa,
  [PaymentMethodNameKnownRegex.AllMastercard]: ContentId.AllMastercard,
};

export const REPORT_FILTER_EDITABILITY_TO_CID: Record<
  ReportFilterEditability,
  ContentId
> = {
  [ReportFilterEditability.Hidden]: ContentId.Hidden,
  [ReportFilterEditability.View]: ContentId.View,
  [ReportFilterEditability.Edit]: ContentId.Edit,
};

export const REPORT_FILTER_EDITABILITY_TO_DESC_CID: Record<
  ReportFilterEditability,
  ContentId
> = {
  [ReportFilterEditability.Hidden]: ContentId.HiddenEditabilityDescription,
  [ReportFilterEditability.View]: ContentId.ViewEditabilityDescription,
  [ReportFilterEditability.Edit]: ContentId.EditEditabilityDescription,
};

export const VENUE_ZONE_CONFIG_TYPE_TO_CID: Record<
  VenueZoneConfigType,
  ContentId
> = {
  [VenueZoneConfigType.Amphitheater]: ContentId.Amphitheater,
  [VenueZoneConfigType.ConcertsSectionsBehindStage]:
    ContentId.ConcertsSectionsBehindStage,
  [VenueZoneConfigType.SportsOrConcertsWith360]:
    ContentId.SportsOrConcertsWith360,
};

export const VENUE_ZONE_SECTION_GROUP_AREA_TYPE_TO_CID: Record<
  SectionGroupAreaType,
  ContentId
> = {
  [SectionGroupAreaType.Center]: ContentId.Center,
  [SectionGroupAreaType.LeftRight]: ContentId.LeftAndRight,
  [SectionGroupAreaType.FarLeftFarRight]: ContentId.FarLeftAndFarRight,
  [SectionGroupAreaType.Front]: ContentId.Front,
  [SectionGroupAreaType.Sides]: ContentId.Sides,
  [SectionGroupAreaType.SideT1]: ContentId.SideTier1,
  [SectionGroupAreaType.SideT2]: ContentId.SideTier2,
  [SectionGroupAreaType.Ends]: ContentId.Ends,
  [SectionGroupAreaType.Rear]: ContentId.Rear,
  [SectionGroupAreaType.Corners]: ContentId.Corners,
  [SectionGroupAreaType.Unknown]: ContentId.Unknown,
};

export const EVENT_STATUS_TO_CID: Record<ApiEventStatus, ContentId> = {
  [ApiEventStatus.Normal]: ContentId.Normal,
  [ApiEventStatus.Postponed]: ContentId.Postponed,
  [ApiEventStatus.Cancelled]: ContentId.Cancelled,
  [ApiEventStatus.Rescheduled]: ContentId.Rescheduled,
  [ApiEventStatus.Relocated]: ContentId.Relocated,
  [ApiEventStatus.RelocatedAndRescheduled]: ContentId.RelocatedAndRescheduled,
  [ApiEventStatus.Draft]: ContentId.Draft,
  [ApiEventStatus.Deleted]: ContentId.Deleted,
  [ApiEventStatus.Contingent]: ContentId.Contingent,
};

export const EVENT_DEMAND_FACTOR_TYPE_TO_CID: Record<
  EventDemandFactorType,
  ContentId
> = {
  [EventDemandFactorType.HomeTeamOdds]: ContentId.Odds,
  [EventDemandFactorType.Opponent]: ContentId.Opponent,
  [EventDemandFactorType.SpotifyPopularity]: ContentId.SpotifyPopularity,
  [EventDemandFactorType.Stakes]: ContentId.Stakes,
  [EventDemandFactorType.Standing]: ContentId.Standing,
  [EventDemandFactorType.Weather]: ContentId.Weather,
};

export const ROW_COMP_SETTING_TO_CID: Record<string, ContentId | string> = {
  0: ContentId.RowCompSettingExactMatch,
  1: '-1',
  3: '-3',
  6: '-6',
};

export const ROW_GROUP_SETTING_TO_CID: Record<
  RowGroupSetting,
  ContentId | string
> = {
  [RowGroupSetting.SingleTwoToFiveSixPlus]: '1 2-5 6+',
  [RowGroupSetting.OneTwoToFiveSixToTwelveThirteenPlus]: '1 2-5 6-12 13+',
  [RowGroupSetting.OneToFiveSixPlus]: '1-5 6+',
  [RowGroupSetting.OneToTenElevenPlus]: '1-10 11+',
  [RowGroupSetting.AllRows]: ContentId.All,
};

export const PURCHASE_ORDER_STATE_TO_CID: Record<
  PurchaseOrderState,
  ContentId
> = {
  [PurchaseOrderState.Active]: ContentId.Active,
  [PurchaseOrderState.Cancelled]: ContentId.Cancelled,
  [PurchaseOrderState.Void]: ContentId.Void,
  [PurchaseOrderState.Drafted]: ContentId.Drafted,
};

export const LISTING_NOTE_TYPE_TO_CID: Record<ListingNoteType, ContentId> = {
  [ListingNoteType.Defect]: ContentId.Defect,
  [ListingNoteType.RestrictionOnUse]: ContentId.RestrictionOnUse,
  [ListingNoteType.Perk]: ContentId.Perk,
  [ListingNoteType.Information]: ContentId.Information,
  [ListingNoteType.ConnectedSeller]: ContentId.ConnectedSeller,
  [ListingNoteType.InternallyGenerated]: ContentId.InternallyGenerated,
};

export const SALE_LINE_ITEM_CHARGE_REASON_TO_CID: Record<
  SaleLineItemChargeReason,
  ContentId
> = {
  [SaleLineItemChargeReason.CancelledProceeds]: ContentId.CancelledProceeds,
  [SaleLineItemChargeReason.DroppedOrderPenalty]: ContentId.DroppedOrderPenalty,
  [SaleLineItemChargeReason.Compensation]: ContentId.Compensation,
  [SaleLineItemChargeReason.Other]: ContentId.Other,
};

export const SALE_LINE_ITEM_CREDIT_REASON_TO_CID: Record<
  SaleLineItemCreditReason,
  ContentId
> = {
  [SaleLineItemCreditReason.ReversedPenalty]: ContentId.ReversedPenalty,
  [SaleLineItemCreditReason.ReversedCharge]: ContentId.ReversedCharge,
  [SaleLineItemCreditReason.ProceedRepayment]: ContentId.ProceedRepayment,
  [SaleLineItemCreditReason.Other]: ContentId.Other,
};

export const COMMAND_OPTION_TYPE_TO_CID: Record<CommandOptionType, ContentId> =
  {
    // Navigation Actions
    [CommandOptionType.NavigateHome]: ContentId.Home,
    [CommandOptionType.NavigateInventory]: ContentId.Inventory,
    [CommandOptionType.NavigateSales]: ContentId.Sales,
    [CommandOptionType.NavigatePurchases]: ContentId.Purchases,
    [CommandOptionType.NavigatePayments]: ContentId.Payments,
    [CommandOptionType.NavigateReports]: ContentId.Reports,
    [CommandOptionType.NavigateSettings]: ContentId.Settings,

    // General Actions
    [CommandOptionType.ToggleTheme]: ContentId.ToggleTheme,
    [CommandOptionType.ToggleSelectionMode]: ContentId.ToggleSelectionMode,
    [CommandOptionType.SelectAll]: ContentId.SelectAll,
    [CommandOptionType.ExpandAll]: ContentId.ExpandAll,
    [CommandOptionType.CollapseAll]: ContentId.CollapseAll,

    // Listing Bulk Actions
    [CommandOptionType.ListingCatchupMode]: ContentId.EnterCatchupMode,
    [CommandOptionType.ListingBulkEditIncreasePrice]: ContentId.IncreasePrice,
    [CommandOptionType.ListingBulkEditDecreasePrice]: ContentId.DecreasePrice,
    [CommandOptionType.ListingBulkEditAdjustFloor]:
      ContentId.AdjustPricingFloor,
    [CommandOptionType.ListingBulkEditAdjustCeiling]:
      ContentId.AdjustPricingCeiling,
    [CommandOptionType.ListingBulkEditAutoPricingSettings]:
      ContentId.AutopricingSettings,
    [CommandOptionType.ListingBulkEditUpdateMarketplacePrices]:
      ContentId.UpdateMarketplacePrices,
    [CommandOptionType.ListingBulkEditAddTags]: ContentId.UpdateTagValues,
    [CommandOptionType.ListingBulkEditRemoveTags]: ContentId.RemoveTagValues,
    [CommandOptionType.ListingBroadcastListing]: ContentId.Broadcast,
    [CommandOptionType.ListingUnbroadcastListing]: ContentId.Unbroadcast,
    [CommandOptionType.ListingBulkEditRemoveHold]: ContentId.RemoveHold,
    [CommandOptionType.ListingBulkEditAddHold]: ContentId.PutOnHold,
    [CommandOptionType.ListingBulkEditListingGroupSettings]:
      ContentId.BulkEditListingGroupSettings,
    [CommandOptionType.ListingsGroupListings]: ContentId.GroupListings,
    [CommandOptionType.ListingBulkEditMoveToGroup]: ContentId.MoveToGroup,
    [CommandOptionType.ListingBulkEditUngroupListings]:
      ContentId.UngroupListings,
    [CommandOptionType.ListingBulkEditChangeEvent]: ContentId.ChangeEvent,
    [CommandOptionType.ListingBulkEditTicketTypeRule]:
      ContentId.SetDeliveryStrategy,
    [CommandOptionType.ListingBulkEditCommissionAction]:
      ContentId.UpdateBuyerCommission,
    [CommandOptionType.ListingBulkEditMarketplaceSeating]:
      ContentId.UpdateMarketplaceSeating,
    [CommandOptionType.ListingBulkEditRemovePredelivery]:
      ContentId.RemovePredelivery,
    [CommandOptionType.ListingBulkEditAutoFulfill]: ContentId.AutoFulfill,
    [CommandOptionType.ListingBulkUpdateBarcodes]: ContentId.UploadBarcodes,
    [CommandOptionType.ListingBulkEditDeliveryType]:
      ContentId.UpdateDeliveryTypeForPlaceholders,
    [CommandOptionType.ListingBulkEditInternalNotes]:
      ContentId.UpdatePrivateNotes,
    [CommandOptionType.ListingBulkEditUpdateListingSettings]:
      ContentId.EditGeneralSettings,
    [CommandOptionType.ListingBulkEditSeatTraits]:
      ContentId.UpdateSeatTraitsForPlaceholders,
    [CommandOptionType.ListingBulkEditWasteTickets]: ContentId.WasteTickets,
    [CommandOptionType.ListingBulkEditDeleteSeatSavers]:
      ContentId.DeletePlaceholders,
    [CommandOptionType.ListingExportListing]: ContentId.ExportListings,
    [CommandOptionType.ListingBulkReturnTicket]: ContentId.ReturnTickets,
    [CommandOptionType.ListingBulkEditUnwasteTickets]: ContentId.UnwasteTickets,

    // Sales Bulk Actions
    [CommandOptionType.SalesBulkEditDeallocate]: ContentId.DeallocateSales,
    [CommandOptionType.SalesBulkEditReject]: ContentId.RejectSales,
    [CommandOptionType.SalesBulkEditCommission]:
      ContentId.UpdateBuyerCommission,
    [CommandOptionType.SalesBulkUpdateBarcodes]: ContentId.UploadBarcodes,
    [CommandOptionType.SalesBulkEditAddTags]: ContentId.UpdateTagValue,
    [CommandOptionType.SalesBulkEditRemoveTags]: ContentId.RemoveTagValues,
    [CommandOptionType.SalesBulkEditMarkAsFulfilled]: ContentId.MarkAsFulfilled,
    [CommandOptionType.SalesBulkMarkSaleAsPaid]: ContentId.MarkAsPaid,
    [CommandOptionType.SalesBulkEditAutoFulfill]: ContentId.UpdateAutoFulfill,
    [CommandOptionType.SalesBulkEditInternalNotes]:
      ContentId.UpdatePrivateNotes,
    [CommandOptionType.SalesBulkEditGeneralSettings]:
      ContentId.EditGeneralSettings,
    [CommandOptionType.SalesExportSales]: ContentId.ExportSales,

    // Purchases Bulk Actions
    [CommandOptionType.PurchasesBulkAdjustCost]: ContentId.AdjustPurchaseCost,
    [CommandOptionType.PurchaseBulkCancelPurchase]: ContentId.CancelPurchase,
    [CommandOptionType.PurchasesBulkConvertPurchasePayment]:
      ContentId.ConvertPurchasePayment,
    [CommandOptionType.PurchaseBulkDeleteTicketGroup]:
      ContentId.CancelTicketGroupsParenth,
    [CommandOptionType.PurchasesBulkEditCommissionAction]:
      ContentId.UpdateBuyerCommission,
    [CommandOptionType.PurchasesBulkEditAddTag]: ContentId.UpdateTagValues,
    [CommandOptionType.PurchasesBulkEditRemoveTag]: ContentId.RemoveTagValues,
    [CommandOptionType.PurchasesBulkMarkPurchaseAsPaid]:
      ContentId.BulkMarkPurchaseAsPaid,
    [CommandOptionType.PurchasesBulkUpdateDeliveryType]:
      ContentId.UpdateDeliveryType,
    [CommandOptionType.PurchasesBulkUpdateInternalNotes]:
      ContentId.UpdatePrivateNotes,
    [CommandOptionType.PurchasesBulkChangeEvent]: ContentId.ChangeEvent,
    [CommandOptionType.PurchasesBulkUpdatePurhcaseCurrencyCode]:
      ContentId.BulkUpdatePurchaseCurrency,
    [CommandOptionType.PurchasesBulkUpdatePurchaseSettings]:
      ContentId.UpdatePurchasedBy,
    [CommandOptionType.PurchasesBulkUpdateSeatTraits]:
      ContentId.UpdateSeatTraits,
    [CommandOptionType.PurchasesBulkUpdateFaceValue]: ContentId.FaceValue,
    [CommandOptionType.PurchasesExportPurchases]: ContentId.ExportPurchases,
  };

export const WINDOW_FUNCTION_TO_CID: Record<WindowFunction, ContentId> = {
  [WindowFunction.NONE]: ContentId.None,
  [WindowFunction.RATIO_TO_REPORT]: ContentId.RatioToReport,
};

export const AGGR_FUNCTION_TO_CID: Record<AggregateFunction, ContentId> = {
  [AggregateFunction.AVG]: ContentId.Avg,
  [AggregateFunction.COUNT]: ContentId.Count,
  [AggregateFunction.SUM]: ContentId.Sum,
};
export const MATH_OPERATOR_TO_CID: Record<MathOperator, ContentId> = {
  [MathOperator.MIN]: ContentId.Min,
  [MathOperator.MAX]: ContentId.Max,
};

export const DAY_OF_WEEK_TO_CID: Record<DayOfWeek, ContentId> = {
  [DayOfWeek.Sunday]: ContentId.Sunday,
  [DayOfWeek.Monday]: ContentId.Monday,
  [DayOfWeek.Tuesday]: ContentId.Tuesday,
  [DayOfWeek.Wednesday]: ContentId.Wednesday,
  [DayOfWeek.Thursday]: ContentId.Thursday,
  [DayOfWeek.Friday]: ContentId.Friday,
  [DayOfWeek.Saturday]: ContentId.Saturday,
};

export const TICKET_STATUS_TO_CID: Record<TicketStatus, ContentId> = {
  [TicketStatus.Cancelled]: ContentId.Cancelled,
  [TicketStatus.Sold]: ContentId.Sold,
  [TicketStatus.Available]: ContentId.Available,
  [TicketStatus.AvailableSold]: ContentId.AvailableOrSold,
};

export const EVENT_NOTIFICATION_TYPE_TO_CID: Record<
  EventNotificationType,
  ContentId
> = {
  [EventNotificationType.Webhook]: ContentId.Webhook,
  [EventNotificationType.Email]: ContentId.Email,
};

export const EVENT_NOTIFICATION_STATUS_TO_CID: Record<
  EventNotificationStatus,
  ContentId
> = {
  [EventNotificationStatus.Active]: ContentId.Active,
  [EventNotificationStatus.Deactivated]: ContentId.Deactivated,
};

export const TAG_VALUE_INHERIT_MODE_TO_CID: Record<
  TagValueInheritMode,
  ContentId
> = {
  [TagValueInheritMode.SyncLiveValue]: ContentId.TakeTheLiveValueOfInventoryTag,
  [TagValueInheritMode.CopyValueOnCreate]: ContentId.TakeSnapshotOfInventoryTag,
  [TagValueInheritMode.DoNotInherit]: ContentId.DoNotTakeValueFromInventoryTag,
};

export const AUTOPRICING_RESULT_STATE_TO_CID: Partial<
  Record<AutoPricingResultType, ContentId>
> = {
  [AutoPricingResultType.PriceHitHardFloor]:
    ContentId.ResultStateMessagePriceAtFloor,
  [AutoPricingResultType.PriceHitRelativeFloor]:
    ContentId.ResultStateMessagePriceAtRelativeFloor,
  [AutoPricingResultType.PriceAboveCeiling]:
    ContentId.ResultStateMessagePriceAboveCeiling,
  [AutoPricingResultType.PriceHitMaxAllowedDrop]:
    ContentId.ResultStateMessagePriceHitMaxAllowedDrop,
  [AutoPricingResultType.InsufficientComparables]:
    ContentId.ResultStateMessageNotEnoughCompsToAutoPrice,
  [AutoPricingResultType.AllPriceUpdatesPaused]: ContentId.PriceUpdatesPaused,
  [AutoPricingResultType.PriceDecreasesPaused]: ContentId.PriceDecreasesPaused,
};

export const AUTOPRICING_PAUSE_TYPE_TO_CID: Record<
  AutoPricingPauseType,
  ContentId
> = {
  [AutoPricingPauseType.PriceDecreases]: ContentId.PriceDecreases,
  [AutoPricingPauseType.AllPriceUpdates]: ContentId.AllPriceUpdates,
};

export const AUTOPRICING_PAUSE_TYPE_TO_TOOLTIP_CID: Record<
  AutoPricingPauseType,
  ContentId
> = {
  [AutoPricingPauseType.PriceDecreases]: ContentId.PauseTypeDecreases,
  [AutoPricingPauseType.AllPriceUpdates]: ContentId.PauseTypeAllUpdates,
};

export const AUTOPRICING_COMPFAILUREACTIONTYPE_TO_CID: Record<
  AutoPricingCompFailureActionType,
  ContentId
> = {
  [AutoPricingCompFailureActionType.DontChangePrice]: ContentId.DontChangePrice,
  [AutoPricingCompFailureActionType.SetPriceToCeiling]:
    ContentId.SetPriceToCeiling,
};

/**
 * Collection operations for filter queries
 */
export const COLLECTION_FILTER_OP_TO_CID: Partial<
  Record<FilterOperationType, ContentId>
> = {
  [FilterOperationType.In]: ContentId.In,
  [FilterOperationType.NotIn]: ContentId.NotIn,
};

/**
 * Collection operations for EventId and PurchaseOrderId text filters
 * Includes In/NotIn for comma-separated multi-value input plus Equals/NotEquals for single-value matching
 */
export const EVENT_AND_PO_FILTER_OP_TO_CID: Partial<
  Record<FilterOperationType, ContentId>
> = {
  [FilterOperationType.In]: ContentId.In,
  [FilterOperationType.NotIn]: ContentId.NotIn,
  [FilterOperationType.Equals]: ContentId.Equals,
  [FilterOperationType.NotEquals]: ContentId.NotEquals,
};

/**
 * Range operations for filter queries (number range)
 */

export const NUMBER_RANGE_FILTER_OP_TO_CID: Partial<
  Record<FilterOperationType, ContentId>
> = {
  [FilterOperationType.GreaterThan]: ContentId.GreaterThan,
  [FilterOperationType.GreaterThanOrEqual]: ContentId.GreaterThanOrEqual,
  [FilterOperationType.LessThan]: ContentId.LessThan,
  [FilterOperationType.LessThanOrEqual]: ContentId.LessThanOrEqual,
  [FilterOperationType.Between]: ContentId.Between,
};

/**
 * Range operations for filter queries (number range)
 */

export const DATE_RANGE_FILTER_OP_TO_CID_V2: Partial<
  Record<FilterOperationType, ContentId>
> = {
  [FilterOperationType.GreaterThan]: ContentId.AfterDate,
  [FilterOperationType.GreaterThanOrEqual]: ContentId.OnOrAfterDate,
  [FilterOperationType.LessThan]: ContentId.BeforeDate,
  [FilterOperationType.LessThanOrEqual]: ContentId.OnOrBeforeDate,
  [FilterOperationType.Between]: ContentId.DateRange,
};

/**
 * Date range operations for filter queries
 */
export const DATE_RANGE_FILTER_OP_TO_CID: Partial<
  Record<FilterOperationType, ContentId>
> = {
  [FilterOperationType.GreaterThanOrEqual]: ContentId.From,
  [FilterOperationType.LessThanOrEqual]: ContentId.To,
  [FilterOperationType.Between]: ContentId.Between,
};

export const FLIGHT_DURATION_TO_CID: Record<
  FlightDuration,
  ContentId | string
> = {
  [FlightDuration.Daily]: ContentId.DailyBudget,
  [FlightDuration.Weekly]: ContentId.WeeklyBudget,
  [FlightDuration.Monthly]: ContentId.MonthlyBudget,
};

export const AD_CAMPAIGN_STATE_TO_CID: Record<
  AdCampaignState,
  ContentId | string
> = {
  [AdCampaignState.Active]: ContentId.Active,
  [AdCampaignState.Paused]: ContentId.Paused,
  [AdCampaignState.Deleted]: ContentId.Deleted,
};

export const RETAIL_TABLE_COLUMN_ID_TO_CONTENT_ID: Record<
  RetailTableColumnId,
  ContentId | string
> = {
  [RetailTableColumnId.Name]: ContentId.Name,
  [RetailTableColumnId.Email]: ContentId.Email,
  [RetailTableColumnId.Phone]: ContentId.Phone,
  [RetailTableColumnId.DefaultPayment]: ContentId.DefaultPaymentMethod,
  [RetailTableColumnId.UnpaidBalance]: ContentId.OutstandingBalance,
  [RetailTableColumnId.UnpaidInvoices]: 'Unpaid Sales',
  [RetailTableColumnId.BillingAddress]: ContentId.BillingAddress,
  [RetailTableColumnId.ShippingAddress]: ContentId.ShippingAddress,
  [RetailTableColumnId.LastActivity]: 'Last Activity',
  [RetailTableColumnId.Notes]: ContentId.Notes,
  [RetailTableColumnId.Actions]: ContentId.Actions,
};

export const SALE_COST_TYPE_TO_CONTENT_ID: Record<SaleCostType, ContentId> = {
  [SaleCostType.Charge]: ContentId.Charge,
  [SaleCostType.Credit]: ContentId.Credit,
  [SaleCostType.Shipping]: ContentId.Shipping,
  [SaleCostType.Taxes]: ContentId.Tax,
  [SaleCostType.Proceeds]: ContentId.Proceed,
};

export const PRE_DELIVERY_STATE_TO_LABEL: Record<PreDeliveryState, ContentId> =
  {
    [PreDeliveryState.NotPreDelivered]: ContentId.NotPreDelivered,
    [PreDeliveryState.PreDelivered]: ContentId.PreDelivered,
    [PreDeliveryState.PartiallyPreDelivered]: ContentId.PartiallyPreDelivered,
  };
